<!-- *************************************************************************
	TEMPLATE
	************************************************************************* -->
<template>
	<div>
		<span aria-live="assertive" role="region">
			<section>
				<BRow class="sign-in-header">
					<BCol>
						<h1>{{ $t('signIn.signInHeader') }}</h1>
					</BCol>
				</BRow>
				<BRow class="errorNotification" v-show="displayError">
					<BCol>
						<h2 aria-live="assertive" role="region">{{ $t(errmsgTitle) }}</h2>
						<p aria-live="assertive" role="region">
							{{ $t(errmsg) }}
						</p>
					</BCol>
				</BRow>
				<BRow class="warnNotification" v-show="displayWarning">
					<BCol>
						<h2 aria-live="assertive" role="region">{{ $t('warnMsg.warnNotifTitle') }}</h2>
						<p aria-live="assertive" role="region">
							{{ $t('warnMsg.warnNotifMessage1') }}
							<a href="#" @click="turnOffMfa">
								{{ $t('warnMsg.warnNotifLink') }}
							</a>
							{{ $t('warnMsg.warnNotifMessage2') }}
						</p>
					</BCol>
				</BRow>
				<BRow class="successNotification" v-show="displaySuccess">
					<BCol>
						<h2 aria-live="assertive" role="region">{{ $t(successMsgTitle) }}</h2>
						<p aria-live="assertive" role="region">
							{{ $t(successMsg) }}
						</p>
					</BCol>
				</BRow>
			</section>
		</span>
		<BRow class="card-padding">
			<BCol>
				<BCard no-body lg="12" class="card-border">
					<BRow>
						<BCol class="leftPanel" lg="5" md="4">
							<transition-group
								tag="div"
								class="checklist-slider"
								:name="pageTransition.slideBack ? 'checklist-slide-back' : 'checklist-slide'"
							>
								<div
									v-if="
										pageTransition.showUserRegistration ||
											pageTransition.showShowResetPassword ||
											pageTransition.showChangePassword
									"
									key="1"
								>
									<BRow id="sign-in-requirements">
										<BCol class="checklist-div">
											<h2>{{ $t('passwordRequirements.title') }}</h2>
											<hr />
											<ul>
												<li>{{ $t('passwordRequirements.rule1') }}</li>
												<li>{{ $t('passwordRequirements.rule2') }}</li>
												<li>{{ $t('passwordRequirements.rule3') }}</li>
												<li>{{ $t('passwordRequirements.rule4') }}</li>
												<li>{{ $t('passwordRequirements.rule5') }}</li>
												<li>{{ $t('passwordRequirements.rule6') }}</li>
												<li>{{ $t('passwordRequirements.rule7') }}</li>
												<li>{{ $t('passwordRequirements.rule8') }}</li>
												<li>{{ $t('passwordRequirements.rule9') }}</li>
											</ul>
										</BCol>
									</BRow>
								</div>
							</transition-group>
						</BCol>
						<BCol lg="7" md="8" class="card-content">
							<BRow id="signin-register-title">
								<BCol>
									<transition-group
										tag="div"
										class="title-slider"
										:name="pageTransition.slideBack ? 'title-slide-back' : 'title-slide'"
									>
										<div v-show="pageTransition.showLogin" key="1">
											<BRow>
												<BCol class="title-div">
													<BRow>
														<BCol>
															<h1>
																{{
																	$t(
																		'signIn.signInTitle'
																	)
																}}
															</h1>
														</BCol>
													</BRow>
												</BCol>
											</BRow>
										</div>
										<div
											v-show="
												pageTransition.showForgotPassword ||
													pageTransition.showShowResetPassword
											"
											key="2"
										>
											<BRow>
												<BCol class="title-div">
													<BRow>
														<BCol lg="10" md="9">
															<h1>
																{{
																	$t(
																		'forgotPassword.forgotPassword'
																	)
																}}
															</h1>
														</BCol>
														<BCol
															lg="2"
															md="3"
															class="dot-padding"
														>
															<span
																class="currentPage"
																v-if="
																	pageTransition.showForgotPassword
																"
															/>
															<span
																class="notCurrentPage"
																v-else
															/>
															<span
																class="progress-spacing"
															/>
															<span
																class="currentPage"
																v-if="
																	pageTransition.showShowResetPassword
																"
															/>
															<span
																class="notCurrentPage"
																v-else
															/>
														</BCol>
													</BRow>
												</BCol>
											</BRow>
										</div>
										<div
											v-show="
												pageTransition.showUserAgreement ||
													pageTransition.showUserRegistration ||
													pageTransition.showRegisterConfirm
											"
											key="3"
										>
											<BRow>
												<BCol class="title-div">
													<BRow>
														<BCol lg="9" md="8">
															<h1>
																{{
																	$t(
																		'registerAgreement.registerTermsTitle'
																	)
																}}
															</h1>
														</BCol>
														<BCol
															lg="3"
															md="4"
															class="dot-padding"
														>
															<span
																class="currentPage"
																v-if="
																	pageTransition.showUserAgreement
																"
															/>
															<span
																class="notCurrentPage"
																v-else
															/>
															<span
																class="progress-spacing"
															/>
															<span
																class="currentPage"
																v-if="
																	pageTransition.showUserRegistration
																"
															/>
															<span
																class="notCurrentPage"
																v-else
															/>
															<span
																class="progress-spacing"
															/>
															<span
																class="currentPage"
																v-if="
																	pageTransition.showRegisterConfirm
																"
															/>
															<span
																class="notCurrentPage"
																v-else
															/>
														</BCol>
													</BRow>
												</BCol>
											</BRow>
										</div>
										<div
											v-show="
												pageTransition.showMfaInfo ||
													pageTransition.showMfaSetup
											"
											key="4"
										>
											<BRow>
												<BCol class="title-div">
													<BRow>
														<BCol lg="11">
															<h1>
																{{
																	$t(
																		'mfaInfo.mfaInfoTitle'
																	)
																}}
															</h1>
														</BCol>
														<BCol lg="1" class="dot-padding">
															<span
																class="currentPage"
																v-if="
																	pageTransition.showMfaInfo
																"
															/>
															<span
																class="notCurrentPage"
																v-else
															/>
															<span
																class="progress-spacing"
															/>
															<span
																class="currentPage"
																v-if="
																	pageTransition.showMfaSetup
																"
															/>
															<span
																class="notCurrentPage"
																v-else
															/>
														</BCol>
													</BRow>
												</BCol>
											</BRow>
										</div>
										<div v-show="pageTransition.showSecondAuth" key="5">
											<BRow>
												<BCol class="title-div">
													<BRow>
														<BCol>
															<h1>
																{{
																	$t(
																		'secondAuth.mfaInfoTitle'
																	)
																}}
															</h1>
														</BCol>
													</BRow>
												</BCol>
											</BRow>
										</div>
										<div v-show="pageTransition.showChangePassword" key="6">
											<BRow>
												<BCol class="title-div">
													<BRow>
														<BCol>
															<h1>
																{{
																	$t(
																		'changePassword.changePassword'
																	)
																}}
															</h1>
														</BCol>
													</BRow>
												</BCol>
											</BRow>
										</div>
									</transition-group>
								</BCol>
							</BRow>
							<BRow id="signin-register-form">
								<BCol>
									<transition-group
										tag="div"
										:class="
											pageTransition.showLogin ||
											pageTransition.showUserAgreement ||
											pageTransition.showForgotPassword
												? 'form-slider-small'
												: 'form-slider'
										"
										:name="pageTransition.slideBack ? 'slide-back' : 'slide'"
									>
										<!-- login -->
										<div v-show="pageTransition.showLogin" key="1">
											<BRow>
												<BCol class="form-div">
													<BaseForm
														@submit="submitLogin"
														ref="loginForm"
													>
														<BFormRow>
															<BCol lg="12">
																<ValidationProvider
																	ref="signInUserName"
																	:detect-input="
																		false
																	"
																	:name="
																		$t(
																			'signIn.userName'
																		)
																	"
																	rules="required|email"
																	v-slot="{
																		errors
																	}"
																>
																	<BRow>
																		<BCol
																			lg="8"
																		>
																			<BaseInput
																				class="
																			inputBox
																		"
																				:label="
																					$t(
																						'signIn.userName'
																					)
																				"
																				:label_optional="
																					$t(
																						'required'
																					)
																				"
																				:is_required="
																					true
																				"
																				:id="
																					getUniqueId(
																						'signIn.userName'
																					)
																				"
																				:automation-id="
																					getAutomationId(
																						'signIn.userName'
																					)
																				"
																				type="email"
																				v-model.trim="
																					signIn.userName
																				"
																				@input="
																					resetValidation(
																						$event,
																						'signInUserName'
																					)
																				"
																				@blur="
																					checkValidation(
																						$event,
																						'signInUserName'
																					)
																				"
																			/>
																		</BCol>
																		<BCol
																			lg="12"
																		>
																			<span
																				v-if="
																					errors[0]
																				"
																				class="label-danger"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																			<span
																				v-else
																				class="label-none"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																		</BCol>
																	</BRow>
																</ValidationProvider>
															</BCol>
														</BFormRow>
														<BFormRow>
															<BCol lg="12">
																<ValidationProvider
																	ref="signInPassword"
																	:name="
																		$t(
																			'signIn.password'
																		)
																	"
																	rules="required"
																	v-slot="{
																		errors
																	}"
																>
																	<BRow>
																		<BCol
																			lg="8"
																		>
																			<BaseInput
																				class="
																						inputBox
																					"
																				:label="
																					$t(
																						'signIn.password'
																					)
																				"
																				:label_optional="
																					$t(
																						'required'
																					)
																				"
																				:is_required="
																					true
																				"
																				:id="
																					getUniqueId(
																						'signIn.password'
																					)
																				"
																				:automation-id="
																					getAutomationId(
																						'signIn.password'
																					)
																				"
																				:type="
																					signIn.showPassword
																						? 'text'
																						: 'password'
																				"
																				v-model="
																					signIn.password
																				"
																			/>
																			<BCol
																				class="show-password"
																			>
																				<font-awesome-icon
																					class="eye-icon"
																					tabindex="0"
																					v-on:keyup.enter="
																						signIn.showPassword = !signIn.showPassword
																					"
																					@click="
																						signIn.showPassword = !signIn.showPassword
																					"
																					:icon="
																						signIn.showPassword
																							? [
																									'fal',
																									'eye'
																							  ]
																							: [
																									'fal',
																									'eye-slash'
																							  ]
																					"
																					:aria-label="
																						signIn.showPassword
																							? $t(
																									'aria.showPassword'
																							  )
																							: $t(
																									'aria.hidePassword'
																							  )
																					"
																				/>
																			</BCol>
																		</BCol>
																		<BCol
																			lg="12"
																		>
																			<span
																				v-if="
																					errors[0]
																				"
																				class="label-danger"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																			<span
																				v-else
																				class="label-none"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																		</BCol>
																	</BRow>
																</ValidationProvider>
															</BCol>
														</BFormRow>
														<BFormRow>
															<BCol
																class="buttonPadding"
																lg="8"
															>
																<BaseButton
																	type="submit"
																	:id="
																		getUniqueId(
																			'signIn.buttonLogin'
																		)
																	"
																	:label="
																		$t(
																			'signIn.buttonLogin'
																		)
																	"
																	:automation-id="
																		getAutomationId(
																			'signIn.buttonLogin'
																		)
																	"
																	:pill="false"
																	variant="up-primary-auth"
																	:disabled="
																		isInvalidSignInEmail ||
																			signIn.password ===
																				''
																	"
																/>
															</BCol>
														</BFormRow>
														<BFormRow>
															<BCol class="link-text">
																<p>
																	<a
																		href="#"
																		@click="
																			goToRegisterTerms(
																				false
																			)
																		"
																	>
																		{{
																			$t(
																				'signIn.signUpLink'
																			)
																		}}
																	</a>

																	{{
																		$t(
																			'signIn.signUp'
																		)
																	}}

																	|

																	<a
																		href="#"
																		@click="
																			goToForgotPassword
																		"
																	>
																		{{
																			$t(
																				'signIn.forgotPasswordLink'
																			)
																		}}
																	</a>
																</p>
															</BCol>
														</BFormRow>
													</BaseForm>
												</BCol>
											</BRow>
										</div>
										<!-- Registration Agreement -->
										<div v-show="pageTransition.showUserAgreement" key="2">
											<BRow>
												<BCol class="form-div">
													<BRow class="agreementPadding">
														<BCol class="subtitle-div" lg="12">
															<h2>
																{{
																	$t(
																		'registerAgreement.agreementTitle'
																	)
																}}
															</h2>
															<BCardBody
																@scroll="handleScroll"
																class="agreementText"
																ref="content"
																tabindex="0"
															>
																<UserAgreementEn
																	v-if="
																		this
																			.$store
																			.state
																			.i18n
																			.locale ===
																			'en'
																	"
																/>
																<UserAgreementFr
																	v-if="
																		this
																			.$store
																			.state
																			.i18n
																			.locale ===
																			'fr'
																	"
																/>
															</BCardBody>
														</BCol>
													</BRow>
													<BRow class="buttonPadding">
														<BCol lg="12" md="auto">
															<BaseButton
																class="rightButton"
																:id="
																	getUniqueId(
																		'registerAgreement.buttonAccept'
																	)
																"
																@click="acceptTerms"
																:label="
																	$t(
																		'registerAgreement.buttonNext'
																	)
																"
																:automation-id="
																	getAutomationId(
																		'registerAgreement.buttonAccept'
																	)
																"
																:pill="false"
																variant="up-primary-auth"
																:disabled="
																	!scrolledToBottom
																"
															/>
														</BCol>
													</BRow>
												</BCol>
											</BRow>
										</div>
										<!-- Register -->
										<div v-show="pageTransition.showUserRegistration" key="3">
											<BRow>
												<BCol class="form-div">
													<BRow>
														<BCol class="subtitle-div" lg="11">
															<h2>
																{{
																	$t(
																		'registration.registerTitle'
																	)
																}}
															</h2>
														</BCol>
													</BRow>
													<BaseForm
														@submit="submitRegistration"
														ref="registerForm"
													>
														<BFormRow>
															<BCol>
																<ValidationProvider
																	ref="registrationUserName"
																	:detect-input="
																		false
																	"
																	:name="
																		$t(
																			'registration.userName'
																		)
																	"
																	rules="required|email"
																	v-slot="{
																		errors,
																		valid
																	}"
																>
																	<BRow>
																		<BCol
																			lg="8"
																		>
																			<BaseInput
																				class="
																			inputBox
																		"
																				:id="
																					getUniqueId(
																						'registration.userName'
																					)
																				"
																				:automation-id="
																					getAutomationId(
																						'registration.userName'
																					)
																				"
																				type="email"
																				:label="
																					$t(
																						'registration.userName'
																					)
																				"
																				:label_optional="
																					$t(
																						'required'
																					)
																				"
																				:is_required="
																					true
																				"
																				v-model.trim="
																					register.userName
																				"
																				@input="
																					resetValidation(
																						$event,
																						'registrationUserName'
																					)
																				"
																				@blur="
																					checkValidation(
																						$event,
																						'registrationUserName'
																					)
																				"
																			/>
																		</BCol>
																		<BCol
																			lg="12"
																		>
																			<slot
																				:valid="
																					valid
																				"
																				:errors="
																					errors
																				"
																			></slot>
																			<span
																				v-if="
																					errors[0]
																				"
																				class="label-danger"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																			<span
																				v-else
																				class="label-none"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																		</BCol>
																	</BRow>
																</ValidationProvider>
															</BCol>
														</BFormRow>
														<BFormRow>
															<BCol lg="12">
																<ValidationProvider
																	ref="registrationPassword"
																	:name="
																		$t(
																			'registration.password'
																		)
																	"
																	vid="registration.password"
																	:rules="
																		'required|pwd_min_len|pwd_max_len|pwd_min_uppercase|pwd_min_lowercase|pwd_min_non_alphanumeric|pwd_min_numeric|pwd_max_repeated|pwd_min_unique|pwd_no_username:@' +
																			$t(
																				'registration.userName'
																			)
																	"
																	v-slot="{
																		errors
																	}"
																>
																	<BRow>
																		<BCol
																			lg="8"
																		>
																			<BaseInput
																				class="
																			inputBox
																		"
																				:id="
																					getUniqueId(
																						'registration.password'
																					)
																				"
																				:automation-id="
																					getAutomationId(
																						'registration.password'
																					)
																				"
																				:type="
																					register.showPassword
																						? 'text'
																						: 'password'
																				"
																				:label="
																					$t(
																						'registration.password'
																					)
																				"
																				:label_optional="
																					$t(
																						'required'
																					)
																				"
																				:is_required="
																					true
																				"
																				v-model.trim="
																					register.password
																				"
																				@input="
																					validateRegisterInfoDebounced()
																				"
																			/>
																			<BCol
																				class="show-password"
																			>
																				<font-awesome-icon
																					class="eye-icon"
																					tabindex="0"
																					v-on:keyup.enter="
																						register.showPassword = !register.showPassword
																					"
																					@click="
																						register.showPassword = !register.showPassword
																					"
																					:icon="
																						register.showPassword
																							? [
																									'fal',
																									'eye'
																							  ]
																							: [
																									'fal',
																									'eye-slash'
																							  ]
																					"
																					:aria-label="
																						register.showPassword
																							? $t(
																									'aria.showPassword'
																							  )
																							: $t(
																									'aria.hidePassword'
																							  )
																					"
																				/>
																			</BCol>
																		</BCol>
																		<BCol
																			lg="12"
																		>
																			<span
																				v-if="
																					errors[0]
																				"
																				class="label-danger"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																			<span
																				v-else
																				class="label-none"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																		</BCol>
																	</BRow>
																</ValidationProvider>
															</BCol>
														</BFormRow>
														<BFormRow>
															<BCol lg="12">
																<ValidationProvider
																	ref="registrationConfirmPassword"
																	:name="
																		$t(
																			'registration.confirmPassword'
																		)
																	"
																	rules="required|confirmed:registration.password"
																	v-slot="{
																		errors
																	}"
																>
																	<BRow>
																		<BCol
																			lg="8"
																		>
																			<BaseInput
																				class="
																						inputBox
																					"
																				:id="
																					getUniqueId(
																						'registration.confirmPassword'
																					)
																				"
																				:automation-id="
																					getAutomationId(
																						'registration.confirmPassword'
																					)
																				"
																				:type="
																					register.showConfirmPassword
																						? 'text'
																						: 'password'
																				"
																				:label="
																					$t(
																						'registration.confirmPassword'
																					)
																				"
																				:label_optional="
																					$t(
																						'required'
																					)
																				"
																				:is_required="
																					true
																				"
																				v-model.trim="
																					register.confirmPassword
																				"
																				@input="
																					validateRegisterInfoDebounced()
																				"
																			/>
																			<BCol
																				class="show-password"
																			>
																				<font-awesome-icon
																					class="eye-icon"
																					tabindex="0"
																					v-on:keyup.enter="
																						register.showConfirmPassword = !register.showConfirmPassword
																					"
																					@click="
																						register.showConfirmPassword = !register.showConfirmPassword
																					"
																					:icon="
																						register.showConfirmPassword
																							? [
																									'fal',
																									'eye'
																							  ]
																							: [
																									'fal',
																									'eye-slash'
																							  ]
																					"
																					:aria-label="
																						register.showConfirmPassword
																							? $t(
																									'aria.showPassword'
																							  )
																							: $t(
																									'aria.hidePassword'
																							  )
																					"
																				/>
																			</BCol>
																		</BCol>

																		<BCol
																			lg="12"
																		>
																			<span
																				v-if="
																					errors[0]
																				"
																				class="label-danger"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																			<span
																				v-else
																				class="label-none"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																		</BCol>
																	</BRow>
																</ValidationProvider>
															</BCol>
														</BFormRow>
														<BRow
															id="sign-in-requirements-mobile"
														>
															<BCol
																class="checklist-mobile-div"
															>
																<h2>
																	{{
																		$t(
																			'passwordRequirements.title'
																		)
																	}}
																</h2>
																<hr />
																<ul>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule1'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule2'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule3'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule4'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule5'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule6'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule7'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule8'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule9'
																			)
																		}}
																	</li>
																</ul>
															</BCol>
														</BRow>
														<BFormRow
															class="registerButtonPadding"
														>
															<BCol lg="6" md="auto">
																<BaseButton
																	:id="
																		getUniqueId(
																			'registration.buttonBack'
																		)
																	"
																	@click="
																		goToRegisterTerms(
																			true
																		)
																	"
																	:label="
																		$t(
																			'registration.buttonBack'
																		)
																	"
																	:automation-id="
																		getAutomationId(
																			'registration.buttonBack'
																		)
																	"
																	:pill="false"
																	variant="register-secondary"
																/>
															</BCol>
															<BCol lg="6" md="auto">
																<BaseButton
																	class="rightButton"
																	type="submit"
																	:id="
																		getUniqueId(
																			'registration.buttonSubmit'
																		)
																	"
																	:label="
																		$t(
																			'registration.buttonSubmit'
																		)
																	"
																	:automation-id="
																		getAutomationId(
																			'registration.buttonSubmit'
																		)
																	"
																	:pill="false"
																	:disabled="
																		isInvalidRegisterInfo
																	"
																	variant="register-primary"
																/>
															</BCol>
														</BFormRow>
													</BaseForm>
												</BCol>
											</BRow>
										</div>
										<!-- Register Confirm -->
										<div v-show="pageTransition.showRegisterConfirm" key="4">
											<BRow>
												<BCol class="form-div">
													<BRow>
														<BCol lg="11">
															<h2>
																{{
																	$t(
																		'registerConfirm.registerConfirmTitle'
																	)
																}}
															</h2>
														</BCol>
													</BRow>
													<BaseForm
														@submit="confirmRegistration"
														ref="confirmRegistrationForm"
													>
														<BFormRow>
															<BCol>
																<p>
																	{{
																		$t(
																			'registerConfirm.verificationDesc'
																		)
																	}}
																</p>
															</BCol>
														</BFormRow>
														<BFormRow>
															<BCol lg="12">
																<ValidationProvider
																	:name="
																		$t(
																			'registerConfirm.verificationCode'
																		)
																	"
																	rules="required"
																	v-slot="{
																		errors
																	}"
																>
																	<BRow>
																		<BCol
																			lg="8"
																		>
																			<BaseInput
																				class="inputBox"
																				:id="
																					getUniqueId(
																						'registerConfirm.verificationCode'
																					)
																				"
																				:automation-id="
																					getAutomationId(
																						'registerConfirm.verificationCode'
																					)
																				"
																				:label="
																					$t(
																						'registerConfirm.verificationCode'
																					)
																				"
																				:label_optional="
																					$t(
																						'required'
																					)
																				"
																				:is_required="
																					true
																				"
																				v-model.trim="
																					registerConfirm.code
																				"
																				maxlength="10"
																			/>
																		</BCol>
																		<BCol
																			lg="12"
																		>
																			<span
																				v-if="
																					errors[0]
																				"
																				class="label-danger"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																			<span
																				v-else
																				class="label-none"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																		</BCol>
																	</BRow>
																</ValidationProvider>
															</BCol>
														</BFormRow>
														<BRow class="resend-confirm">
															<BCol>
																<a
																	href="#"
																	@click="
																		onResend
																	"
																	>{{
																		$t(
																			'registerConfirm.buttonResend'
																		)
																	}}</a
																>
															</BCol>
														</BRow>
														<BRow>
															<BCol
																lg="12"
																md="auto"
																class="confirmButton"
															>
																<BaseButton
																	class="rightButton"
																	type="submit"
																	:id="
																		getUniqueId(
																			'registerConfirm.buttonConfirm'
																		)
																	"
																	:label="
																		$t(
																			'registerConfirm.buttonConfirm'
																		)
																	"
																	:automation-id="
																		getAutomationId(
																			'registerConfirm.buttonConfirm'
																		)
																	"
																	:pill="false"
																	variant="up-primary-auth"
																	:disabled="
																		registerConfirm
																			.code
																			.length <
																			6
																	"
																/>
															</BCol>
														</BRow>
													</BaseForm>
												</BCol>
											</BRow>
										</div>
										<!-- Registered -->
										<div v-show="pageTransition.showRegistered" key="5">
											<BRow>
												<BCol class="form-div">
													<BRow class="success-margin">
														<BCol lg="2" md="2">
															<img
																src="../../assets/success-check.png"
																class="success-image"
															/>
														</BCol>
														<BCol
															lg="9"
															md="9"
															class="success-title"
														>
															<h2>
																{{
																	$t(
																		'registered.registeredTitle'
																	)
																}}
															</h2>
														</BCol>
													</BRow>
													<BRow class="contentTextPadding">
														<BCol lg="2" md="2" />
														<BCol class="success-text">
															<p>
																{{
																	$t(
																		'registered.verificationMessage'
																	)
																}}
															</p>
														</BCol>
													</BRow>
													<BRow class="continueButton">
														<BCol lg="12" md="12">
															<BaseButton
																class="rightButton"
																:id="
																	getUniqueId(
																		'registered.buttonSignIn'
																	)
																"
																@click="goToSignIn"
																:label="
																	$t(
																		'registered.buttonSignIn'
																	)
																"
																:automation-id="
																	getAutomationId(
																		'registered.buttonSignIn'
																	)
																"
																:pill="false"
																variant="up-secondary-auth"
															/>
														</BCol>
													</BRow>
												</BCol>
											</BRow>
										</div>
										<!--forgot password page-->
										<div v-show="pageTransition.showForgotPassword" key="6">
											<BRow>
												<BCol class="form-div">
													<BRow>
														<BCol lg="11" class="subtitle-div">
															<h2>
																{{
																	$t(
																		'forgotPassword.forgotPasswordSubTitle'
																	)
																}}
															</h2>
														</BCol>
													</BRow>
													<BaseForm
														@submit="onFindAccount"
														ref="forgotPassword"
													>
														<BFormRow>
															<BCol
																lg="11"
																md="11"
																sm="11"
																xs="6"
															>
																<p>
																	{{
																		$t(
																			'forgotPassword.forgotPasswordMessage'
																		)
																	}}
																</p>
															</BCol>
														</BFormRow>
														<BFormRow>
															<BCol lg="12">
																<ValidationProvider
																	ref="forgotPasswordEmail"
																	:detect-input="
																		false
																	"
																	:name="
																		$t(
																			'forgotPassword.email'
																		)
																	"
																	rules="required|email"
																	v-slot="{
																		errors
																	}"
																>
																	<BRow>
																		<BCol
																			lg="8"
																		>
																			<BaseInput
																				type="email"
																				class="
																			inputBox
																		"
																				:id="
																					getUniqueId(
																						'forgotPassword.email'
																					)
																				"
																				:automation-id="
																					getAutomationId(
																						'forgotPassword.email'
																					)
																				"
																				:label="
																					$t(
																						'forgotPassword.email'
																					)
																				"
																				:label_optional="
																					$t(
																						'required'
																					)
																				"
																				:is_required="
																					true
																				"
																				v-model.trim="
																					forgotPassword.email
																				"
																				@input="
																					resetValidation(
																						$event,
																						'forgotPasswordEmail'
																					)
																				"
																				@blur="
																					checkValidation(
																						$event,
																						'forgotPasswordEmail'
																					)
																				"
																			/>
																		</BCol>
																		<BCol
																			lg="12"
																		>
																			<span
																				v-if="
																					errors[0]
																				"
																				class="label-danger"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																			<span
																				v-else
																				class="label-none"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																		</BCol>
																	</BRow>
																</ValidationProvider>
															</BCol>
														</BFormRow>
														<BRow class="forgot-password">
															<BCol lg="6" md="6">
																<BaseButton
																	@click="
																		goToSignIn
																	"
																	:id="
																		getUniqueId(
																			'forgotPassword.cancelButton'
																		)
																	"
																	:label="
																		$t(
																			'forgotPassword.cancelButton'
																		)
																	"
																	:automation-id="
																		getAutomationId(
																			'forgotPassword.cancelButton'
																		)
																	"
																	:pill="false"
																	variant="up-secondary-auth"
																/>
															</BCol>
															<BCol lg="6" md="6">
																<BaseButton
																	class="rightButton"
																	type="submit"
																	:id="
																		getUniqueId(
																			'forgotPassword.nextButton'
																		)
																	"
																	:label="
																		$t(
																			'forgotPassword.nextButton'
																		)
																	"
																	:automation-id="
																		getAutomationId(
																			'forgotPassword.nextButton'
																		)
																	"
																	:pill="false"
																	:disabled="
																		isInvalidEmail
																	"
																	variant="up-primary-auth"
																/>
															</BCol>
														</BRow>
													</BaseForm>
												</BCol>
											</BRow>
										</div>
										<!--password reset page-->
										<div v-show="pageTransition.showShowResetPassword" key="7">
											<BRow>
												<BCol class="form-div" style="position: static">
													<BaseForm
														@submit="onSetPassword"
														ref="resetPassword"
													>
														<BFormRow>
															<BCol lg="12">
																<ValidationProvider
																	ref="resetPasswordResetCode"
																	:name="
																		$t(
																			'resetPassword.resetCode'
																		)
																	"
																	rules="required"
																	v-slot="{
																		errors
																	}"
																>
																	<BRow>
																		<BCol
																			lg="8"
																		>
																			<BaseInput
																				class="
																			inputBox
																		"
																				:id="
																					getUniqueId(
																						'resetPassword.resetCode'
																					)
																				"
																				:automation-id="
																					getAutomationId(
																						'resetPassword.resetCode'
																					)
																				"
																				:label="
																					$t(
																						'resetPassword.resetCode'
																					)
																				"
																				:label_optional="
																					$t(
																						'required'
																					)
																				"
																				:is_required="
																					true
																				"
																				v-model.trim="
																					resetPassword.resetCode
																				"
																				@input="
																					validateForgotPasswordDebounced()
																				"
																				maxlength="10"
																			/>
																		</BCol>
																		<BCol
																			lg="12"
																		>
																			<span
																				v-if="
																					errors[0]
																				"
																				class="label-danger"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																			<span
																				v-else
																				class="label-none"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																		</BCol>
																	</BRow>
																</ValidationProvider>
															</BCol>
														</BFormRow>
														<BFormRow>
															<BCol class="forgot-password">
																<p>
																	{{
																		$t(
																			'resetPassword.resendCodeMsg1'
																		)
																	}}
																	<a
																		href="#"
																		@click="
																			onFindAccount
																		"
																		>{{
																			$t(
																				'resetPassword.buttonResend'
																			)
																		}}</a
																	>
																</p>
															</BCol>
														</BFormRow>
														<BFormRow>
															<BCol lg="12">
																<ValidationProvider
																	ref="resetPasswordNewPassword"
																	:name="
																		$t(
																			'resetPassword.newPassword'
																		)
																	"
																	vid="resetPassword.password"
																	rules="required|pwd_min_len|pwd_max_len|pwd_min_uppercase|pwd_min_lowercase|pwd_min_non_alphanumeric|pwd_min_numeric|pwd_max_repeated|pwd_min_unique"
																	v-slot="{
																		errors
																	}"
																>
																	<BRow>
																		<BCol
																			lg="8"
																		>
																			<BaseInput
																				:type="
																					resetPassword.showNewPassword
																						? 'text'
																						: 'password'
																				"
																				class="
																			inputBox
																		"
																				:id="
																					getUniqueId(
																						'resetPassword.newPassword'
																					)
																				"
																				:automation-id="
																					getAutomationId(
																						'resetPassword.newPassword'
																					)
																				"
																				:label="
																					$t(
																						'resetPassword.newPassword'
																					)
																				"
																				:label_optional="
																					$t(
																						'required'
																					)
																				"
																				:is_required="
																					true
																				"
																				v-model.trim="
																					resetPassword.newPassword
																				"
																				@input="
																					validateForgotPasswordDebounced()
																				"
																			/>
																			<BCol
																				class="show-password"
																			>
																				<font-awesome-icon
																					class="eye-icon"
																					tabindex="0"
																					v-on:keyup.enter="
																						resetPassword.showNewPassword = !resetPassword.showNewPassword
																					"
																					@click="
																						resetPassword.showNewPassword = !resetPassword.showNewPassword
																					"
																					:icon="
																						resetPassword.showNewPassword
																							? [
																									'fal',
																									'eye'
																							  ]
																							: [
																									'fal',
																									'eye-slash'
																							  ]
																					"
																					:aria-label="
																						resetPassword.showNewPassword
																							? $t(
																									'aria.showPassword'
																							  )
																							: $t(
																									'aria.hidePassword'
																							  )
																					"
																				/>
																			</BCol>
																		</BCol>

																		<BCol
																			lg="12"
																		>
																			<span
																				v-if="
																					errors[0]
																				"
																				class="label-danger"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																			<span
																				v-else
																				class="label-none"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																		</BCol>
																	</BRow>
																</ValidationProvider>
															</BCol>
														</BFormRow>
														<BFormRow>
															<BCol lg="12">
																<ValidationProvider
																	ref="resetPasswordConfirmPassword"
																	:name="
																		$t(
																			'resetPassword.confirmPassword'
																		)
																	"
																	rules="required|confirmed:resetPassword.password"
																	v-slot="{
																		errors
																	}"
																>
																	<BRow>
																		<BCol
																			lg="8"
																		>
																			<BaseInput
																				:type="
																					resetPassword.showConfirmPassword
																						? 'text'
																						: 'password'
																				"
																				class="
																			inputBox
																		"
																				:id="
																					getUniqueId(
																						'resetPassword.confirmPassword'
																					)
																				"
																				:automation-id="
																					getAutomationId(
																						'resetPassword.confirmPassword'
																					)
																				"
																				:label="
																					$t(
																						'resetPassword.confirmPassword'
																					)
																				"
																				:label_optional="
																					$t(
																						'required'
																					)
																				"
																				:is_required="
																					true
																				"
																				v-model.trim="
																					resetPassword.confirmPassword
																				"
																				@input="
																					validateForgotPasswordDebounced()
																				"
																			/>
																			<BCol
																				class="
																				show-password
																			"
																			>
																				<font-awesome-icon
																					class="eye-icon"
																					tabindex="0"
																					v-on:keyup.enter="
																						resetPassword.showConfirmPassword = !resetPassword.showConfirmPassword
																					"
																					@click="
																						resetPassword.showConfirmPassword = !resetPassword.showConfirmPassword
																					"
																					:icon="
																						resetPassword.showConfirmPassword
																							? [
																									'fal',
																									'eye'
																							  ]
																							: [
																									'fal',
																									'eye-slash'
																							  ]
																					"
																					:aria-label="
																						resetPassword.showConfirmPassword
																							? $t(
																									'aria.showPassword'
																							  )
																							: $t(
																									'aria.hidePassword'
																							  )
																					"
																				/>
																			</BCol>
																		</BCol>

																		<BCol
																			lg="12"
																		>
																			<span
																				v-if="
																					errors[0]
																				"
																				class="label-danger"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																			<span
																				v-else
																				class="label-none"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																		</BCol>
																	</BRow>
																</ValidationProvider>
															</BCol>
														</BFormRow>
														<BRow
															id="sign-in-requirements-mobile"
														>
															<BCol
																class="checklist-mobile-div"
															>
																<h2>
																	{{
																		$t(
																			'passwordRequirements.title'
																		)
																	}}
																</h2>
																<hr />
																<ul>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule1'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule2'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule3'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule4'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule5'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule6'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule7'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule8'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule9'
																			)
																		}}
																	</li>
																</ul>
															</BCol>
														</BRow>
														<BRow class="forgot-password">
															<BCol lg="5" md="auto">
																<BaseButton
																	@click="
																		goToForgotPassword
																	"
																	:id="
																		getUniqueId(
																			'resetPassword.cancelButton'
																		)
																	"
																	:label="
																		$t(
																			'resetPassword.cancelButton'
																		)
																	"
																	:automation-id="
																		getAutomationId(
																			'resetPassword.cancelButton'
																		)
																	"
																	:pill="false"
																	variant="changePassword-secondary"
																/>
															</BCol>
															<BCol lg="6" md="auto">
																<BaseButton
																	class="rightButton"
																	type="submit"
																	:id="
																		getUniqueId(
																			'resetPassword.changePasswordButton'
																		)
																	"
																	:label="
																		$t(
																			'resetPassword.changePasswordButton'
																		)
																	"
																	:automation-id="
																		getAutomationId(
																			'resetPassword.changePasswordButton'
																		)
																	"
																	:pill="false"
																	:disabled="
																		isInvalidForgotPasswordInfo
																	"
																	variant="changePassword-primary"
																/>
															</BCol>
														</BRow>
													</BaseForm>
												</BCol>
											</BRow>
										</div>
										<!-- MFA Information -->
										<div v-show="pageTransition.showMfaInfo" key="8">
											<BRow>
												<BCol class="form-div">
													<BRow class="mfaInfoPadding">
														<BCol lg="12">
															<h2>
																{{
																	$t(
																		'mfaInfo.mfaInfoHeader'
																	)
																}}
															</h2>
															<BCardBody
																@scroll="handleScroll"
																class="mfaInfoText"
																ref="content"
															>
																<p>
																	{{
																		$t(
																			'mfaInfo.mfaDescParagraph1'
																		)
																	}}
																</p>
																<p>
																	{{
																		$t(
																			'mfaInfo.mfaDescParagraph2'
																		)
																	}}
																</p>
																<p>
																	{{
																		$t(
																			'mfaInfo.mfaDescParagraph3'
																		)
																	}}
																</p>
																<p>
																	{{
																		$t(
																			'mfaInfo.mfaDescParagraph4'
																		)
																	}}
																</p>
															</BCardBody>
														</BCol>
													</BRow>
													<BRow>
														<BCol>
															<BaseButton
																@click="mfaWarn"
																:id="
																	getUniqueId(
																		'mfaInfo.buttonMFAOff'
																	)
																"
																:label="
																	$t(
																		'mfaInfo.buttonMFAOff'
																	)
																"
																:automation-id="
																	getAutomationId(
																		'mfaInfo.buttonMFAOff'
																	)
																"
																:pill="false"
																variant="up-link"
															/>
														</BCol>
														<BCol>
															<BaseButton
																class="rightButton"
																@click="goToMfaSetup"
																:id="
																	getUniqueId(
																		'mfaInfo.buttonContinue'
																	)
																"
																:label="
																	$t(
																		'mfaInfo.buttonContinue'
																	)
																"
																:automation-id="
																	getAutomationId(
																		'mfaInfo.buttonContinue'
																	)
																"
																:pill="false"
																variant="up-primary-auth"
																:disabled="
																	!scrolledToBottom
																"
															/>
														</BCol>
													</BRow>
												</BCol>
											</BRow>
										</div>
										<!-- MFA Setup -->
										<div v-show="pageTransition.showMfaSetup" key="9">
											<BRow>
												<BCol class="form-div">
													<BaseForm @submit="turnOnMfa">
														<BRow>
															<BCol>
																<BFormRow
																	class="mfaInfoPadding"
																>
																	<BCol lg="11">
																		<h2>
																			{{
																				$t(
																					'mfaSetup.mfaSetupHeader'
																				)
																			}}
																		</h2>
																	</BCol>
																</BFormRow>
																<BFormRow
																	class="mfaInfoPadding"
																>
																	<BCol lg="4">
																		<qrcode-vue
																			class="
																				qrcode
																			"
																			:value="
																				qrCode
																			"
																			:size="
																				150
																			"
																			level="L"
																			renderAs="svg"
																			margin="10"
																		/>
																	</BCol>
																	<BCol
																		lg="1"
																	/>
																	<BCol
																		lg="6"
																		class="
																			mfaSetupText
																		"
																	>
																		<p>
																			{{
																				$t(
																					'mfaSetup.mfaSetupText'
																				)
																			}}
																		</p>
																		<p>
																			{{
																				$t(
																					'mfaSetup.mfaSetupText2'
																				)
																			}}
																			<a
																				href="#"
																				>{{
																					$t(
																						'mfaSetup.mfaSetupLink'
																					)
																				}}</a
																			>
																		</p>
																	</BCol>
																	<BCol
																		lg="1"
																	/>
																</BFormRow>
																<BFormRow>
																	<BCol lg="12">
																		<ValidationProvider
																			ref="mfaSetupQrInput"
																			:name="
																				$t(
																					'mfaSetup.qrCodeInput'
																				)
																			"
																			rules="required"
																			v-slot="{
																				errors
																			}"
																		>
																			<BRow>
																				<BCol
																					lg="8"
																				>
																					<BaseInput
																						class="
																					inputBox
																				"
																						:id="
																							getUniqueId(
																								'mfaSetup.qrCodeInput'
																							)
																						"
																						:automation-id="
																							getAutomationId(
																								'mfaSetup.qrCodeInput'
																							)
																						"
																						:label="
																							$t(
																								'mfaSetup.qrCodeInput'
																							)
																						"
																						:label_optional="
																							$t(
																								'required'
																							)
																						"
																						:is_required="
																							true
																						"
																						v-model.trim="
																							mfaSetup.authCode
																						"
																					/>
																				</BCol>
																				<BCol
																					lg="12"
																				>
																					<span
																						v-if="
																							errors[0]
																						"
																						class="label-danger"
																					>
																						{{
																							errors[0]
																						}}
																					</span>
																					<span
																						v-else
																						class="label-none"
																					>
																						{{
																							errors[0]
																						}}
																					</span>
																				</BCol>
																			</BRow>
																		</ValidationProvider>
																	</BCol>
																</BFormRow>
																<BRow
																	class="second-auth"
																>
																	<BCol>
																		<BaseButton
																			:id="
																				getUniqueId(
																					'mfaSetup.mfaBackButton'
																				)
																			"
																			@click="
																				goToMfaInfo(
																					true
																				)
																			"
																			:label="
																				$t(
																					'mfaSetup.mfaBackButton'
																				)
																			"
																			:automation-id="
																				getAutomationId(
																					'mfaSetup.mfaBackButton'
																				)
																			"
																			:pill="
																				false
																			"
																			variant="up-primary-auth"
																		/>
																	</BCol>
																	<BCol>
																		<BaseButton
																			class="
																				rightButton
																			"
																			type="submit"
																			:id="
																				getUniqueId(
																					'mfaSetup.mfaVerifyButton'
																				)
																			"
																			:label="
																				$t(
																					'mfaSetup.mfaVerifyButton'
																				)
																			"
																			:automation-id="
																				getAutomationId(
																					'mfaSetup.mfaVerifyButton'
																				)
																			"
																			:pill="
																				false
																			"
																			variant="up-primary-auth"
																			:disabled="
																				mfaSetup
																					.authCode
																					.length <
																					6
																			"
																		/>
																	</BCol>
																</BRow>
															</BCol>
														</BRow>
													</BaseForm>
												</BCol>
											</BRow>
										</div>
										<!-- secondAuth -->
										<div v-show="pageTransition.showSecondAuth" key="10">
											<BRow>
												<BCol class="form-div">
													<BaseForm @submit="onSubmit">
														<BRow class="mfaSetupPadding">
															<BCol>
																<BFormRow
																	class="mfaInfoPadding"
																>
																	<BCol lg="11">
																		<h2>
																			{{
																				$t(
																					'secondAuth.mfaSetupHeader'
																				)
																			}}
																		</h2>
																	</BCol>
																</BFormRow>
																<BFormRow
																	class="mfaInfoPadding"
																>
																	<BCol
																		class="
																			mfaSetupText
																		"
																	>
																		<p>
																			{{
																				$t(
																					'secondAuth.mfaSetupText'
																				)
																			}}
																		</p>
																	</BCol>
																	<BCol
																		lg="1"
																	/>
																</BFormRow>
																<BFormRow>
																	<BCol lg="12">
																		<ValidationProvider
																			ref="mfaSetupQrInput"
																			:name="
																				$t(
																					'secondAuth.qrCodeInput'
																				)
																			"
																			rules="required"
																			v-slot="{
																				errors
																			}"
																		>
																			<BRow>
																				<BCol
																					lg="8"
																				>
																					<BaseInput
																						class="
																					inputBox
																				"
																						:id="
																							getUniqueId(
																								'secondAuth.qrCodeInput'
																							)
																						"
																						:automation-id="
																							getAutomationId(
																								'secondAuth.qrCodeInput'
																							)
																						"
																						:label="
																							$t(
																								'secondAuth.qrCodeInput'
																							)
																						"
																						:label_optional="
																							$t(
																								'required'
																							)
																						"
																						:is_required="
																							true
																						"
																						v-model.trim="
																							secondAuth.totpCode
																						"
																					/>
																				</BCol>
																				<BCol
																					lg="12"
																				>
																					<span
																						v-if="
																							errors[0]
																						"
																						class="label-danger"
																					>
																						{{
																							errors[0]
																						}}
																					</span>
																					<span
																						v-else
																						class="label-none"
																					>
																						{{
																							errors[0]
																						}}
																					</span>
																				</BCol>
																			</BRow>
																		</ValidationProvider>
																	</BCol>
																</BFormRow>
																<BRow
																	class="
																		second-auth
																	"
																>
																	<BCol>
																		<BaseButton
																			class="
																				rightButton
																			"
																			type="submit"
																			:id="
																				getUniqueId(
																					'secondAuth.secondAuthButton'
																				)
																			"
																			:label="
																				$t(
																					'secondAuth.mfaVerifyButton'
																				)
																			"
																			:automation-id="
																				getAutomationId(
																					'secondAuth.secondAuthButton'
																				)
																			"
																			:pill="
																				false
																			"
																			variant="up-primary-auth"
																			:disabled="
																				secondAuth
																					.totpCode
																					.length <
																					6
																			"
																		/>
																	</BCol>
																	<BCol
																		lg="1"
																	/>
																</BRow>
															</BCol>
														</BRow>
													</BaseForm>
												</BCol>
											</BRow>
										</div>
										<!-- Change Password -->
										<div v-show="pageTransition.showChangePassword" key="11">
											<BRow>
												<BCol class="form-div" style="position: static">
													<BaseForm
														@submit="submitChangePassword"
														ref="changePasswordForm"
													>
														<BFormRow>
															<BCol lg="12">
																<ValidationProvider
																	ref="changePasswordLastPassword"
																	:name="
																		$t(
																			'changePassword.lastPassword'
																		)
																	"
																	rules="required"
																	v-slot="{
																		errors
																	}"
																>
																	<BRow>
																		<BCol
																			lg="8"
																		>
																			<BaseInput
																				class="inputBox"
																				:id="
																					getUniqueId(
																						'changePassword.lastPassword'
																					)
																				"
																				:automation-id="
																					getAutomationId(
																						'changePassword.lastPassword'
																					)
																				"
																				:type="
																					changePassword.showOldPassword
																						? 'text'
																						: 'password'
																				"
																				:label="
																					$t(
																						'changePassword.lastPassword'
																					)
																				"
																				:label_optional="
																					$t(
																						'required'
																					)
																				"
																				:is_required="
																					true
																				"
																				v-model.trim="
																					changePassword.oldPassword
																				"
																			/>
																			<BCol
																				class="show-password"
																			>
																				<font-awesome-icon
																					class="eye-icon"
																					tabindex="0"
																					v-on:keyup.enter="
																						changePassword.showOldPassword = !changePassword.showOldPassword
																					"
																					@click="
																						changePassword.showOldPassword = !changePassword.showOldPassword
																					"
																					:icon="
																						changePassword.showOldPassword
																							? [
																									'fal',
																									'eye'
																							  ]
																							: [
																									'fal',
																									'eye-slash'
																							  ]
																					"
																					:aria-label="
																						changePassword.showOldPassword
																							? $t(
																									'aria.showPassword'
																							  )
																							: $t(
																									'aria.hidePassword'
																							  )
																					"
																				/>
																			</BCol>
																		</BCol>
																		<BCol
																			lg="12"
																		>
																			<span
																				v-if="
																					errors[0]
																				"
																				class="label-danger"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																			<span
																				v-else
																				class="label-none"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																		</BCol>
																	</BRow>
																</ValidationProvider>
															</BCol>
														</BFormRow>
														<BFormRow>
															<BCol lg="12">
																<ValidationProvider
																	ref="changePasswordNewPassword"
																	:name="
																		$t(
																			'changePassword.newPassword'
																		)
																	"
																	vid="changePassword.password"
																	:rules="
																		'required|pwd_min_len|pwd_max_len|pwd_min_uppercase|pwd_min_lowercase|pwd_min_non_alphanumeric|pwd_min_numeric|pwd_max_repeated|pwd_min_unique|pwd_no_old_password:@' +
																			$t(
																				'changePassword.lastPassword'
																			)
																	"
																	v-slot="{
																		errors
																	}"
																>
																	<BRow>
																		<BCol
																			lg="8"
																		>
																			<BaseInput
																				class="inputBox"
																				:id="
																					getUniqueId(
																						'changePassword.newPassword'
																					)
																				"
																				:automation-id="
																					getAutomationId(
																						'changePassword.newPassword'
																					)
																				"
																				:type="
																					changePassword.showNewPassword
																						? 'text'
																						: 'password'
																				"
																				:label="
																					$t(
																						'changePassword.newPassword'
																					)
																				"
																				:label_optional="
																					$t(
																						'required'
																					)
																				"
																				:is_required="
																					true
																				"
																				v-model.trim="
																					changePassword.newPassword
																				"
																			/>
																			<BCol
																				class="show-password"
																			>
																				<font-awesome-icon
																					class="eye-icon"
																					tabindex="0"
																					v-on:keyup.enter="
																						changePassword.showNewPassword = !changePassword.showNewPassword
																					"
																					@click="
																						changePassword.showNewPassword = !changePassword.showNewPassword
																					"
																					:icon="
																						changePassword.showNewPassword
																							? [
																									'fal',
																									'eye'
																							  ]
																							: [
																									'fal',
																									'eye-slash'
																							  ]
																					"
																					:aria-label="
																						changePassword.showNewPassword
																							? $t(
																									'aria.showPassword'
																							  )
																							: $t(
																									'aria.hidePassword'
																							  )
																					"
																				/>
																			</BCol>
																		</BCol>

																		<BCol
																			lg="12"
																		>
																			<span
																				v-if="
																					errors[0]
																				"
																				class="label-danger"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																			<span
																				v-else
																				class="label-none"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																		</BCol>
																	</BRow>
																</ValidationProvider>
															</BCol>
														</BFormRow>
														<BFormRow>
															<BCol lg="12">
																<ValidationProvider
																	ref="changePasswordConfirmPassword"
																	:name="
																		$t(
																			'changePassword.confirmPassword'
																		)
																	"
																	rules="required|confirmed:changePassword.password"
																	v-slot="{
																		errors
																	}"
																>
																	<BRow>
																		<BCol
																			lg="8"
																		>
																			<BaseInput
																				class="inputBox"
																				:id="
																					getUniqueId(
																						'changePassword.confirmPassword'
																					)
																				"
																				:automation-id="
																					getAutomationId(
																						'changePassword.confirmPassword'
																					)
																				"
																				:type="
																					changePassword.showConfirmPassword
																						? 'text'
																						: 'password'
																				"
																				:label="
																					$t(
																						'changePassword.confirmPassword'
																					)
																				"
																				:label_optional="
																					$t(
																						'required'
																					)
																				"
																				:is_required="
																					true
																				"
																				v-model.trim="
																					changePassword.confirmPassword
																				"
																			/>
																			<BCol
																				class="show-password"
																			>
																				<font-awesome-icon
																					class="eye-icon"
																					tabindex="0"
																					v-on:keyup.enter="
																						changePassword.showConfirmPassword = !changePassword.showConfirmPassword
																					"
																					@click="
																						changePassword.showConfirmPassword = !changePassword.showConfirmPassword
																					"
																					:icon="
																						changePassword.showConfirmPassword
																							? [
																									'fal',
																									'eye'
																							  ]
																							: [
																									'fal',
																									'eye-slash'
																							  ]
																					"
																					:aria-label="
																						changePassword.showConfirmPassword
																							? $t(
																									'aria.showPassword'
																							  )
																							: $t(
																									'aria.hidePassword'
																							  )
																					"
																				/>
																			</BCol>
																		</BCol>

																		<BCol
																			lg="12"
																		>
																			<span
																				v-if="
																					errors[0]
																				"
																				class="label-danger"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																			<span
																				v-else
																				class="label-none"
																			>
																				{{
																					errors[0]
																				}}
																			</span>
																		</BCol>
																	</BRow>
																</ValidationProvider>
															</BCol>
														</BFormRow>
														<BRow
															id="sign-in-requirements-mobile"
														>
															<BCol
																class="checklist-mobile-div"
															>
																<h2>
																	{{
																		$t(
																			'passwordRequirements.title'
																		)
																	}}
																</h2>
																<hr />
																<ul>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule1'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule2'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule3'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule4'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule5'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule6'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule7'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule8'
																			)
																		}}
																	</li>
																	<li>
																		{{
																			$t(
																				'passwordRequirements.rule9'
																			)
																		}}
																	</li>
																</ul>
															</BCol>
														</BRow>
														<BRow class="changePasswordLastRow">
															<BCol lg="5" md="auto">
																<BaseButton
																	@click="
																		signOut
																	"
																	:id="
																		getUniqueId(
																			'changePassword.cancelButton'
																		)
																	"
																	:label="
																		$t(
																			'changePassword.cancelButton'
																		)
																	"
																	:automation-id="
																		getAutomationId(
																			'changePassword.cancelButton'
																		)
																	"
																	:pill="false"
																	variant="changePassword-secondary"
																/>
															</BCol>
															<BCol lg="6" md="auto">
																<BaseButton
																	class="rightButton"
																	type="submit"
																	:id="
																		getUniqueId(
																			'changePassword.changePasswordButton'
																		)
																	"
																	:label="
																		$t(
																			'changePassword.changePasswordButton'
																		)
																	"
																	:automation-id="
																		getAutomationId(
																			'changePassword.changePasswordButton'
																		)
																	"
																	:pill="false"
																	variant="changePassword-primary"
																/>
															</BCol>
														</BRow>
													</BaseForm>
												</BCol>
											</BRow>
										</div>
										<!-- Change Password Success -->
										<div v-show="pageTransition.showChangeSuccess" key="12">
											<BRow>
												<BCol class="form-div">
													<BRow>
														<BCol lg="2" md="2">
															<img
																src="../../assets/success-check.png"
																class="success-change-password-image"
															/>
														</BCol>
														<BCol
															lg="9"
															md="9"
															class="successChangePasswordTitlePadding"
														>
															<h2>
																{{
																	$t(
																		'changeSuccess.changePasswordSuccessTitle'
																	)
																}}
															</h2>
														</BCol>
													</BRow>
													<BRow class="contentTextPadding">
														<BCol lg="2" md="2" />
														<BCol class="success-text">
															<p>
																{{
																	$t(
																		'changeSuccess.successMessage'
																	)
																}}
															</p>
															<p>
																{{
																	$t(
																		'changeSuccess.successMessageAddtl'
																	)
																}}
															</p>
														</BCol>
													</BRow>
													<BRow class="continueButton">
														<BCol lg="12">
															<BaseButton
																class="rightButton"
																:id="
																	getUniqueId(
																		'changeSuccess.continueButton'
																	)
																"
																@click="signOut"
																:label="
																	$t(
																		'changeSuccess.continueButton'
																	)
																"
																:automation-id="
																	getAutomationId(
																		'changeSuccess.continueButton'
																	)
																"
																:pill="false"
																variant="up-secondary-auth"
															/>
														</BCol>
													</BRow>
												</BCol>
											</BRow>
										</div>
									</transition-group>
								</BCol>
							</BRow>
						</BCol>
					</BRow>
				</BCard>
			</BCol>
		</BRow>
		<div v-if="loading" id="loadingContainer">
			<div id="loadingBox">
				<font-awesome-icon
					id="loadingIcon"
					:icon="['fas', 'sync-alt']"
					class="fa-spin"
					:automation-id="getAutomationId('loading-icon')"
				/>
			</div>
		</div>
	</div>
</template>
<!-- *************************************************************************
		SCRIPT
		************************************************************************* -->

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import IdMixin from '@/mixins/id';
import TabTrackerMixin from '@/mixins/tabs';
import BaseButton from '@/components/common/base/auth/BaseButton.vue';
import BaseInput from '@/components/common/base/BaseInput.vue';
import BaseForm from '@/components/common/base/auth/BaseForm.vue';
import { BRow, BCol, BCard, BFormRow, BCardBody } from 'bootstrap-vue';
import { ValidationProvider } from 'vee-validate';
import QrcodeVue from 'qrcode.vue';
import Registration from '@/models/Registration';
import Profile from '@/models/Profile';
import Preferences from '@/models/Preferences';
import Eligibility from '@/models/Eligibility';
import UserAgreementEn from '@/components/auth/UserAgreementEn.vue';
import UserAgreementFr from '@/components/auth/UserAgreementFr.vue';
import _ from 'lodash';
@Component({
	name: 'LoginRegister',
	components: {
		BaseButton,
		BaseInput,
		BaseForm,
		BFormRow,
		BRow,
		BCol,
		BCard,
		BCardBody,
		ValidationProvider,
		QrcodeVue,
		UserAgreementEn,
		UserAgreementFr
	},
	props: {
		automationId: {
			type: String,
			required: true
		},
		pwdrules: 'pwd-min-len|pwd-min-uppercase'
	},
	computed: {
		qrCode: function() {
			return this.$store.state.auth.qrCode;
		},
		qrSecret: function() {
			return this.$store.state.auth.secret;
		},
		errcode: function() {
			return this.$store.state.auth.errcode;
		}
	},
	watch: {
		errcode() {
			console.log('watched error code: ' + this.errcode);
			if (this.errcode !== '') {
				if (this.errcode === '"AuthenticateUserSuccess"') {
					this.showNotification();
					this.goToSignedInPage();
				} else if (this.errcode === '"SignUpSuccess"') {
					this.showNotification();
					this.registerBeneficiary();
					this.goToRegisterConfirm();
				} else if (this.errcode === '"TotpRequired"') {
					this.showNotification();
					this.goToSecondAuth();
				} else if (this.errcode === '"VerificationCodeSentSuccess"') {
					this.showNotification();
					this.goToPasswordReset();
				} else if (this.errcode === '"ConfirmPasswordSuccess"') {
					this.showNotification('successMsg.passwordReset', 'successMsg.passwordResetTitle', 'SUCCESS');
					this.goToSignIn('PASSWORD_RESET');
				} else if (this.errcode === '"ConfirmRegistrationSuccess"') {
					this.showNotification();
					this.goToRegistered();
				} else if (this.errcode === '"SendMFACodeSuccess"') {
					this.showNotification();
					if (this.loginScenario === 'EXPIRED_PASSWORD') {
						this.goToChangePassword();
					} else {
						this.goToLandingPage();
					}
				} else if (this.errcode === '"MFATurnedOn"') {
					this.showNotification();
					this.goToLandingPage();
				} else if (this.errcode === '"AssociateSoftwareTokenSuccess"') {
					this.showNotification();
				} else if (this.errcode === '"ChangePasswordSuccess"') {
					this.showNotification();
					this.goToPasswordChangeSuccess();
				} else if (this.errcode === '"SignOutSuccess"') {
					console.log('user signed out');
				} else if (this.errcode === '"ResendConfirmationCodeSuccess"') {
					this.showNotification('successMsg.resentCode', 'successMsg.resentCodeTitle', 'SUCCESS');
				} else if (this.errcode === '"NotAuthorizedException"') {
					this.showNotification('errmsg.incorrectCredentials', 'errmsg.errmsgTitle', 'ERROR');
				} else if (this.errcode === '"UserNotFoundException"') {
					this.showNotification('errmsg.incorrectCredentials', 'errmsg.errmsgTitle', 'ERROR');
				} else if (this.errcode === '"UsernameExistsException"') {
					this.showNotification('errmsg.userNameExists', 'errmsg.errmsgTitle', 'ERROR');
				} else if (this.errcode === '"CodeMismatchException"') {
					this.showNotification('errmsg.invalidVerification', 'errmsg.errmsgTitle', 'ERROR');
				} else if (this.errcode === '"InvalidParameterException"') {
					this.showNotification('errmsg.invalidVerification', 'errmsg.errmsgTitle', 'ERROR');
				} else if (this.errcode === '"UserNotConfirmedException"') {
					this.$store.commit('setUsername', this.signIn.userName);
					this.resend = true;
					this.goToRegisterConfirm();
					this.showNotification('errmsg.registrationNotConfirmed', 'errmsg.errmsgTitle', 'ERROR');
				} else if (this.errcode === '"LimitExceededException"') {
					this.limitExceededError();
				} else if (this.errcode === '"EnableSoftwareTokenMFAException"') {
					this.errmsg = this.$t('mfaCodeInvalid');
				} else {
					this.showNotification('errmsg.default', 'errmsg.errmsgTitle', 'ERROR');
				}
			}
		}
	},
	mixins: [IdMixin, TabTrackerMixin]
})
export default class Register extends Vue {
	loginScenario = '';
	errmsgTitle = '';
	successMsgTitle = '';
	scrolledToBottom = false;
	registrationResponse = '';
	deleteUserResponse = '';
	userProfileResponse = '';
	userProfile = '';
	userPreferencesResponse = '';
	userPreferences = '';
	acceptTermsResponse = '';
	eligibilityResponse = '';
	turnOnMfaResponse = '';
	turnOffMfaResponse = '';
	mfaFirstLogin = false;
	loading = false;
	isInvalidRegisterInfo = true;
	isInvalidEmail = true;
	isInvalidForgotPasswordInfo = true;
	isInvalidSignInEmail = true;

	async getLoginScenario() {
		this.loading = true;
		this.userProfileResponse = await Profile.find(
			{
				email: this.$store.state.auth.username
			},
			this.$store.state.auth.tokens.idToken
		);

		this.userPreferencesResponse = await Preferences.find(this.$store.state.auth.username, this.$store.state.auth.tokens.idToken);

		// JIRCC-3627
		if (this.userProfileResponse.message && this.userProfileResponse.message.includes('Network Error')) {
			this.$store.dispatch('signOut');
			this.closeTabs();
			this.showNotification('errmsg.userEligibilityError', 'errmsg.errmsgTitle', 'ERROR');
			this.loading = false;
		}

		if (
			(this.userProfileResponse.code && this.userProfileResponse.code === 'ECONNABORTED') ||
			(this.userPreferencesResponse.code && this.userPreferencesResponse.code === 'ECONNABORTED')
		) {
			console.log('user profile api response code: ' + this.userProfileResponse.code);
			console.log('user preference api response code: ' + this.userPreferencesResponse.code);
			this.$store.dispatch('signOut');
			this.closeTabs();
			this.showNotification('errmsg.timeoutError', 'errmsg.errmsgTitle', 'ERROR');
			this.loading = false;
		}

		if (this.userProfileResponse.status === 500 || this.userPreferencesResponse.status === 500) {
			this.showNotification('errmsg.userProfileError', 'errmsg.errmsgTitle', 'ERROR');
			this.$store.dispatch('signOut');
			this.closeTabs();
			this.loading = false;
		} else if (this.userProfileResponse.status === 404) {
			// JIRCC-3605 - a ben pref record not found in the db
			this.showNotification('errmsg.userProfileNotFound', 'errmsg.errmsgTitle', 'ERROR');
			this.$store.dispatch('signOut');
			this.closeTabs();
			this.loading = false;
		} else {
			this.userProfile = this.userProfileResponse.data;
			this.userPreferences = this.userPreferencesResponse.data;
			this.$store.commit('changeUci', this.userProfile.uci);
			this.$store.commit('setFirstName', this.userProfile.firstName);
			this.$store.commit('setLastName', this.userProfile.lastName);
			this.$store.commit('setlastLoginTime', this.userProfile.lastLoginTime);
			this.$store.commit('setAddressLines', this.userProfile.addressLines);
			this.$store.commit('setBirthDate', this.userProfile.birthDate);

			if (this.userProfile.uci === null) {
				this.loading = false;
				this.$store.commit('setValidate', true);
				return 'VALIDATE';
			} else {
				this.eligibilityResponse = await Eligibility.findEligibleCoverages(
					this.userProfile.uci,
					this.$store.state.auth.tokens.idToken
				);
				if (this.eligibilityResponse.code && this.eligibilityResponse.code === 'ECONNABORTED') {
					this.$store.dispatch('signOut');
					this.closeTabs();
					this.showNotification('errmsg.timeoutError', 'errmsg.errmsgTitle', 'ERROR');
					this.loading = false;
				} else {
					if (this.eligibilityResponse.status === 400) {
						this.showNotification('errmsg.userEligibilityError', 'errmsg.errmsgTitle', 'ERROR');
						this.$store.dispatch('signOut');
						this.closeTabs();
						this.loading = false;
					} else if (this.getMfaFirstLoginStatus(this.userPreferences.mfaInd)) {
						this.loading = false;
						return 'MFA_FIRST';
					} else if (this.userProfile.passwordExpired) {
						this.loading = false;
						this.$store.commit('setExpiredPassword', true);
						return 'EXPIRED_PASSWORD';
					} else if (this.userProfile.agreementVersion !== window.ENV.AGREEMENT_VERSION) {
						this.loading = false;
						this.$store.commit('setAcceptTerms', true);
						return 'ACCEPT_TERMS';
					} else {
						this.loading = false;
						return 'MFA_OFF';
					}
				}
			}
		}
	}

	limitExceededError() {
		if (this.pageTransition.showLogin) {
			this.showNotification('errmsg.limitExceededLocked', 'errmsg.errmsgTitle', 'ERROR');
		} else if (this.pageTransition.showForgotPassword || this.pageTransition.showShowResetPassword) {
			this.showNotification('errmsg.limitExceededForgotPassword', 'errmsg.errmsgTitle', 'ERROR');
		} else if (this.pageTransition.showChangePassword) {
			this.showNotification('errmsg.limitExceededChangePassword', 'errmsg.errmsgTitle', 'ERROR');
		}
	}

	async acceptAgreementTerms() {
		this.loading = true;
		this.userProfile.agreementVersion = window.ENV.AGREEMENT_VERSION;
		this.acceptTermsResponse = await Profile.acceptAgreement(this.userProfile, this.$store.state.auth.tokens.idToken);
		if (this.acceptTermsResponse.code && this.acceptTermsResponse.code === 'ECONNABORTED') {
			this.showNotification('errmsg.timeoutError', 'errmsg.errmsgTitle', 'ERROR');
			this.loading = false;
		} else {
			if (this.acceptTermsResponse.status === 500 || this.acceptTermsResponse.status === 404) {
				this.showNotification('errmsg.userProfileError', 'errmsg.errmsgTitle', 'ERROR');
			} else {
				this.$store.commit('setAcceptTerms', false);
				this.goToSignedInPage();
			}
			this.loading = false;
		}
	}

	async turnOnMfa() {
		this.loading = true;
		this.turnOnMfaResponse = await Preferences.saveSecretCode({ email: this.userPreferences.email, code: this.$store.state.auth.secret });
		if (this.turnOnMfaResponse.code && this.turnOnMfaResponse.code === 'ECONNABORTED') {
			this.showNotification('errmsg.timeoutError', 'errmsg.errmsgTitle', 'ERROR');
			this.loading = false;
		} else {
			if (this.turnOnMfaResponse.status === 500 || this.turnOnMfaResponse.status === 404) {
				this.showNotification('errmsg.userProfileError', 'errmsg.errmsgTitle', 'ERROR');
			} else {
				this.$store.dispatch('turnOnMFA', this.mfaSetup.authCode);
			}
			this.loading = false;
		}
	}

	async turnOffMfa() {
		this.loading = true;
		this.userPreferences.mfaInd = false;
		this.turnOffMfaResponse = await Preferences.save(this.userPreferences);
		if (this.turnOffMfaResponse.code && this.turnOffMfaResponse.code === 'ECONNABORTED') {
			this.showNotification('errmsg.timeoutError', 'errmsg.errmsgTitle', 'ERROR');
			this.loading = false;
		} else {
			if (this.turnOffMfaResponse.status === 500 || this.turnOffMfaResponse.status === 404) {
				this.showNotification('errmsg.userProfileError', 'errmsg.errmsgTitle', 'ERROR');
			} else {
				this.$router.push({ name: 'home' });
			}
			this.loading = false;
		}
	}

	getMfaFirstLoginStatus(mfaPreference) {
		if (mfaPreference && !this.$store.state.auth.mfaOn) {
			return true;
		}
		return false;
	}

	showNotification(message, title, notifType) {
		if (notifType === 'ERROR') {
			this.displayError = true;
			this.displaySuccess = false;
			this.displayWarning = false;
			this.errmsg = message;
			this.errmsgTitle = title;
		} else if (notifType === 'SUCCESS') {
			this.displayError = false;
			this.displaySuccess = true;
			this.displayWarning = false;
			this.successMsg = message;
			this.successMsgTitle = title;
		} else {
			this.displayError = false;
			this.displaySuccess = false;
			this.displayWarning = false;
		}
	}

	pageTransition = {
		showLogin: true,
		showUserAgreement: false,
		showUserRegistration: false,
		showRegisterConfirm: false,
		showRegistered: false,
		showForgotPassword: false,
		showShowResetPassword: false,
		showMfaInfo: false,
		showMfaSetup: false,
		showSecondAuth: false,
		showChangePassword: false,
		showChangeSuccess: false,
		slideBack: false
	};

	signIn = {
		userName: '',
		password: '',
		showPassword: false
	};

	register = {
		userName: '',
		password: '',
		confirmPassword: '',
		showPassword: false,
		showConfirmPassword: false
	};

	registerConfirm = {
		code: ''
	};

	forgotPassword = {
		email: ''
	};

	resetPassword = {
		resetCode: '',
		newPassword: '',
		confirmPassword: '',
		showNewPassword: false,
		showConfirmPassword: false
	};

	mfaSetup = {
		authCode: ''
	};

	secondAuth = {
		totpCode: ''
	};

	changePassword = {
		oldPassword: '',
		newPassword: '',
		confirmPassword: '',
		showOldPassword: false,
		showNewPassword: false,
		showConfirmPassword: false
	};

	errmsg = '';
	displayError = false;
	successMsg = '';
	displaySuccess = false;
	displayWarning = false;

	goToForgotPassword() {
		this.$refs.forgotPasswordEmail.reset();
		this.forgotPassword = {
			email: ''
		};
		this.displayError = false;
		this.displaySuccess = false;
		this.displayWarning = false;
		this.pageTransition.showLogin = false;
		this.pageTransition.showUserAgreement = false;
		this.pageTransition.showUserRegistration = false;
		this.pageTransition.showRegisterConfirm = false;
		this.pageTransition.showRegistered = false;
		this.pageTransition.showForgotPassword = true;
		this.pageTransition.showShowResetPassword = false;
		this.pageTransition.showMfaInfo = false;
		this.pageTransition.showMfaSetup = false;
		this.pageTransition.showSecondAuth = false;
		this.pageTransition.showChangePassword = false;
		this.pageTransition.showChangeSuccess = false;
		this.pageTransition.slideBack = false;
		this.isInvalidEmail = true;
	}

	goToPasswordReset() {
		this.resetPassword = {
			resetCode: '',
			newPassword: '',
			confirmPassword: '',
			showNewPassword: false,
			showConfirmPassword: false
		};
		this.displayError = false;
		this.displaySuccess = false;
		this.displayWarning = false;
		this.pageTransition.showForgotPassword = false;
		this.pageTransition.showShowResetPassword = true;
		this.pageTransition.showLogin = false;
		this.pageTransition.showUserAgreement = false;
		this.pageTransition.showUserRegistration = false;
		this.pageTransition.showRegisterConfirm = false;
		this.pageTransition.showRegistered = false;
		this.pageTransition.showMfaInfo = false;
		this.pageTransition.showMfaSetup = false;
		this.pageTransition.showSecondAuth = false;
		this.pageTransition.showChangePassword = false;
		this.pageTransition.showChangeSuccess = false;
		this.pageTransition.slideBack = false;
		this.isInvalidEmail = true;
	}

	goToSignIn(scenario) {
		if (scenario === 'PASSWORD_RESET') {
			Preferences.passwordReset({ email: this.forgotPassword.email });
		}

		this.$refs.signInUserName.reset();
		this.signIn = {
			userName: '',
			password: '',
			showPassword: false
		};

		this.displayError = false;
		this.displayWarning = false;
		this.pageTransition.showShowResetPassword = false;
		this.pageTransition.showLogin = true;
		this.pageTransition.showForgotPassword = false;
		this.pageTransition.showUserAgreement = false;
		this.pageTransition.showUserRegistration = false;
		this.pageTransition.showRegisterConfirm = false;
		this.pageTransition.showRegistered = false;
		this.pageTransition.showMfaInfo = false;
		this.pageTransition.showMfaSetup = false;
		this.pageTransition.showSecondAuth = false;
		this.pageTransition.showChangePassword = false;
		this.pageTransition.showChangeSuccess = false;
		this.pageTransition.slideBack = true;
		this.isInvalidEmail = true;
		this.isInvalidSignInEmail = true;
	}

	goToMfaInfo(slideback) {
		this.displayError = false;
		this.displaySuccess = false;
		this.displayWarning = false;
		this.pageTransition.showShowResetPassword = false;
		this.pageTransition.showLogin = false;
		this.pageTransition.showForgotPassword = false;
		this.pageTransition.showUserAgreement = false;
		this.pageTransition.showUserRegistration = false;
		this.pageTransition.showRegisterConfirm = false;
		this.pageTransition.showRegistered = false;
		this.pageTransition.showMfaInfo = true;
		this.pageTransition.showMfaSetup = false;
		this.pageTransition.showSecondAuth = false;
		this.pageTransition.showChangePassword = false;
		this.pageTransition.showChangeSuccess = false;
		this.pageTransition.slideBack = slideback;
	}

	goToMfaSetup() {
		this.mfaSetup = {
			authCode: ''
		};
		this.displayError = false;
		this.displaySuccess = false;
		this.displayWarning = false;
		this.$store.dispatch('generateQrCode');
		this.pageTransition.showShowResetPassword = false;
		this.pageTransition.showLogin = false;
		this.pageTransition.showForgotPassword = false;
		this.pageTransition.showUserAgreement = false;
		this.pageTransition.showUserRegistration = false;
		this.pageTransition.showRegisterConfirm = false;
		this.pageTransition.showRegistered = false;
		this.pageTransition.showMfaInfo = false;
		this.pageTransition.showMfaSetup = true;
		this.pageTransition.showSecondAuth = false;
		this.pageTransition.showChangePassword = false;
		this.pageTransition.showChangeSuccess = false;
		this.pageTransition.slideBack = false;
	}

	goToSecondAuth() {
		this.secondAuth = {
			totpCode: ''
		};
		this.displayError = false;
		this.displaySuccess = false;
		this.displayWarning = false;
		this.pageTransition.showShowResetPassword = false;
		this.pageTransition.showLogin = false;
		this.pageTransition.showForgotPassword = false;
		this.pageTransition.showUserAgreement = false;
		this.pageTransition.showUserRegistration = false;
		this.pageTransition.showRegisterConfirm = false;
		this.pageTransition.showRegistered = false;
		this.pageTransition.showMfaInfo = false;
		this.pageTransition.showMfaSetup = false;
		this.pageTransition.showSecondAuth = true;
		this.pageTransition.showChangePassword = false;
		this.pageTransition.showChangeSuccess = false;
		this.pageTransition.slideBack = false;
	}

	goToRegister() {
		this.$refs.registrationUserName.reset();
		this.register = {
			userName: '',
			password: '',
			confirmPassword: '',
			showPassword: false,
			showConfirmPassword: false
		};

		this.displayError = false;
		this.displaySuccess = false;
		this.displayWarning = false;
		this.pageTransition.showLogin = false;
		this.pageTransition.showUserAgreement = false;
		this.pageTransition.showUserRegistration = true;
		this.pageTransition.showRegisterConfirm = false;
		this.pageTransition.showRegistered = false;
		this.pageTransition.showShowResetPassword = false;
		this.pageTransition.showForgotPassword = false;
		this.pageTransition.showMfaInfo = false;
		this.pageTransition.showMfaSetup = false;
		this.pageTransition.showSecondAuth = false;
		this.pageTransition.showChangePassword = false;
		this.pageTransition.showChangeSuccess = false;
		this.pageTransition.slideBack = false;
		this.isInvalidRegisterInfo = true;
		this.isInvalidEmail = true;
	}

	acceptTerms() {
		if (this.$store.state.auth.acceptTerms) {
			this.acceptAgreementTerms();
		} else {
			this.goToRegister();
		}
	}

	goToRegisterTerms(slideBack) {
		this.displayError = false;
		this.displaySuccess = false;
		this.displayWarning = false;
		this.pageTransition.showLogin = false;
		this.pageTransition.showUserRegistration = false;
		this.pageTransition.showUserAgreement = true;
		this.pageTransition.showRegisterConfirm = false;
		this.pageTransition.showRegistered = false;
		this.pageTransition.showShowResetPassword = false;
		this.pageTransition.showForgotPassword = false;
		this.pageTransition.showMfaInfo = false;
		this.pageTransition.showMfaSetup = false;
		this.pageTransition.showSecondAuth = false;
		this.pageTransition.showChangePassword = false;
		this.pageTransition.showChangeSuccess = false;
		this.pageTransition.slideBack = slideBack;
	}

	goToRegisterConfirm() {
		this.registerConfirm = {
			code: ''
		};

		this.displayError = false;
		this.displaySuccess = false;
		this.displayWarning = false;
		this.pageTransition.showLogin = false;
		this.pageTransition.showUserAgreement = false;
		this.pageTransition.showUserRegistration = false;
		this.pageTransition.showRegisterConfirm = true;
		this.pageTransition.showRegistered = false;
		this.pageTransition.showShowResetPassword = false;
		this.pageTransition.showForgotPassword = false;
		this.pageTransition.showMfaInfo = false;
		this.pageTransition.showMfaSetup = false;
		this.pageTransition.showSecondAuth = false;
		this.pageTransition.showChangePassword = false;
		this.pageTransition.showChangeSuccess = false;
		this.pageTransition.slideBack = false;
	}

	goToRegistered() {
		this.displayError = false;
		this.displaySuccess = false;
		this.displayWarning = false;
		this.pageTransition.showLogin = false;
		this.pageTransition.showUserAgreement = false;
		this.pageTransition.showUserRegistration = false;
		this.pageTransition.showRegisterConfirm = false;
		this.pageTransition.showRegistered = true;
		this.pageTransition.showShowResetPassword = false;
		this.pageTransition.showForgotPassword = false;
		this.pageTransition.showMfaInfo = false;
		this.pageTransition.showMfaSetup = false;
		this.pageTransition.showSecondAuth = false;
		this.pageTransition.showChangePassword = false;
		this.pageTransition.showChangeSuccess = false;
		this.pageTransition.slideBack = false;
	}

	goToChangePassword() {
		this.changePassword = {
			oldPassword: '',
			newPassword: '',
			confirmPassword: '',
			showOldPassword: false,
			showNewPassword: false,
			showConfirmPassword: false
		};
		this.displayError = false;
		this.displaySuccess = false;
		this.displayWarning = false;
		this.pageTransition.showLogin = false;
		this.pageTransition.showUserAgreement = false;
		this.pageTransition.showUserRegistration = false;
		this.pageTransition.showRegisterConfirm = false;
		this.pageTransition.showRegistered = false;
		this.pageTransition.showShowResetPassword = false;
		this.pageTransition.showForgotPassword = false;
		this.pageTransition.showMfaInfo = false;
		this.pageTransition.showMfaSetup = false;
		this.pageTransition.showSecondAuth = false;
		this.pageTransition.showChangeSuccess = false;
		this.pageTransition.showChangePassword = true;
		this.pageTransition.slideBack = false;
	}

	goToPasswordChangeSuccess() {
		Preferences.changedPassword(
			{ email: this.$store.state.auth.username, isPasswordReset: false, expiredPasswordChange: true },
			this.$store.state.auth.tokens.idToken
		);

		this.displayError = false;
		this.displaySuccess = false;
		this.displayWarning = false;
		this.pageTransition.showLogin = false;
		this.pageTransition.showUserAgreement = false;
		this.pageTransition.showUserRegistration = false;
		this.pageTransition.showRegisterConfirm = false;
		this.pageTransition.showRegistered = false;
		this.pageTransition.showShowResetPassword = false;
		this.pageTransition.showForgotPassword = false;
		this.pageTransition.showMfaInfo = false;
		this.pageTransition.showMfaSetup = false;
		this.pageTransition.showSecondAuth = false;
		this.pageTransition.showChangeSuccess = true;
		this.pageTransition.showChangePassword = false;
		this.pageTransition.slideBack = false;
	}

	goToLandingPage() {
		this.$router.push({ name: 'home' });
	}

	checkValidation(evt, refs) {
		this.$refs[refs].value = evt.target.value;
		this.$refs[refs].validate();
	}

	async resetValidation(inputValue, refs) {
		if (refs === 'signInUserName') {
			this.$refs[refs].value = inputValue;
			const validation = await this.$refs[refs].validateSilent();
			this.isInvalidSignInEmail = !validation.valid;
		}

		if (refs === 'forgotPasswordEmail') {
			this.$refs[refs].value = inputValue;
			const validation = await this.$refs[refs].validateSilent();
			this.isInvalidEmail = !validation.valid;
		}

		if (refs === 'registrationUserName') {
			this.$refs[refs].value = inputValue;
			const validation = await this.$refs[refs].validateSilent();
			this.isInvalidRegisterInfo = !(
				validation.valid &&
				this.$refs.registrationPassword.flags.valid &&
				this.$refs.registrationConfirmPassword.flags.valid
			);
		}

		if (!this.$refs[refs].errors.length) {
			return;
		}
		this.$refs[refs].reset();
	}

	submitLogin() {
		this.$refs.signInUserName.validate();
		this.$refs.signInPassword.validate();
		if (this.$refs.signInUserName.flags.valid && this.$refs.signInPassword.flags.valid) {
			this.$store.commit('setError', '');
			let authData = {
				Username: this.signIn.userName,
				Password: this.signIn.password,
				SignedInPage: null,
				totpInputPage: null
			};
			this.$store.dispatch('signIn', authData);
		}
	}

	async goToSignedInPage() {
		this.loginScenario = await this.getLoginScenario();
		console.log('login scenario: ' + this.loginScenario);
		if (this.loginScenario == 'VALIDATE') {
			this.$router.push('validate');
		} else if (this.loginScenario == 'MFA_FIRST') {
			this.goToMfaInfo();
		} else if (this.loginScenario == 'EXPIRED_PASSWORD') {
			this.goToChangePassword();
		} else if (this.loginScenario == 'ACCEPT_TERMS') {
			this.goToRegisterTerms();
		} else if (typeof this.loginScenario != 'undefined') {
			this.$router.push({ name: 'home' });
		}
	}

	onSetPassword() {
		this.$refs.resetPasswordResetCode.validate();
		this.$refs.resetPasswordNewPassword.validate();
		this.$refs.resetPasswordConfirmPassword.validate();
		if (
			this.$refs.resetPasswordResetCode.flags.valid &&
			this.$refs.resetPasswordNewPassword.flags.valid &&
			this.$refs.resetPasswordConfirmPassword.flags.valid
		) {
			this.$store.commit('setError', '');
			var userData = {
				username: this.forgotPassword.email,
				code: this.resetPassword.resetCode,
				password: this.resetPassword.newPassword
			};

			this.$store.dispatch('confirmPassword', userData);
		}
	}

	async submitRegistration() {
		this.$refs.registrationUserName.validate();
		this.$refs.registrationPassword.validate();
		this.$refs.registrationConfirmPassword.validate();
		if (
			this.$refs.registrationUserName.flags.valid &&
			this.$refs.registrationPassword.flags.valid &&
			this.$refs.registrationConfirmPassword.flags.valid
		) {
			this.$store.commit('setError', '');
			let userData = {
				email: this.register.userName,
				password: this.register.password,
				confirmPage: null
			};

			const response = await Registration.pingRegistrationApi(this.register.userName);

			if (response.status === 200) {
				this.$store.dispatch('signUp', userData);
			} else {
				this.showNotification('errmsg.userEligibilityError', 'errmsg.errmsgTitle', 'ERROR');
			}
		}
	}

	confirmRegistration() {
		this.$store.commit('setError', '');
		let userData = {
			code: this.registerConfirm.code,
			confirmedPage: null
		};

		this.$store.dispatch('confirmRegistration', userData);
	}

	async registerBeneficiary() {
		this.loading = true;
		this.registrationResponse = await Registration.registerUser({
			userSub: this.$store.state.auth.userSub,
			email: this.$store.state.auth.username,
			agreementVersion: window.ENV.AGREEMENT_VERSION
		});
		if (this.registrationResponse.code && this.registrationResponse.code === 'ECONNABORTED') {
			this.showNotification('errmsg.timeoutError', 'errmsg.errmsgTitle', 'ERROR');
			this.loading = false;
		} else {
			if (this.registrationResponse.status === 500 || this.registrationResponse.status === 404) {
				// this doesn't work because there's no token passed; only AdminDeleteUser will work
				// this.deleteUser(null);
				// JIRCC-3605 - we won't display this error since the user can still complete the cognito registration portion
				// an appropriate error message will be displayed during login (userProfielNotFound).
				// this.errmsg = this.showNotification('errmsg.registrationError', 'errmsg.errmsgTitle', 'ERROR');
			} else {
				this.showNotification();
				this.goToRegisterConfirm();
			}
			this.loading = false;
		}
	}

	async deleteUser(deletionScenario) {
		this.loading = true;
		this.deleteUserResponse = await Registration.deleteUser(this.$store.state.auth.username, this.$store.state.auth.tokens.idToken);
		if (this.deleteUserResponse.code && this.deleteUserResponse.code === 'ECONNABORTED') {
			this.showNotification('errmsg.timeoutError', 'errmsg.errmsgTitle', 'ERROR');
			this.loading = false;
		} else {
			this.$store.dispatch('deleteUser');
			if (deletionScenario === 'COVERAGE_EXPIRED') {
				this.$router.push({ name: 'validate-failed', query: { failureScenario: deletionScenario } });
			}
			this.loading = false;
		}
	}

	onResend() {
		this.$store.commit('setError', '');
		this.$store.dispatch('resendConfirmationCode', null);
	}

	onFindAccount() {
		this.$refs.forgotPasswordEmail.validate();
		if (this.$refs.forgotPasswordEmail.flags.valid) {
			this.$store.commit('setError', '');
			console.log('find account: ' + this.forgotPassword.email);
			this.$store.dispatch('forgotPassword', this.forgotPassword.email);
		}
	}

	onSubmit() {
		this.$store.dispatch('validateTotpCode', this.secondAuth.totpCode);
	}

	submitChangePassword() {
		this.$refs.changePasswordLastPassword.validate();
		this.$refs.changePasswordNewPassword.validate();
		this.$refs.changePasswordConfirmPassword.validate();
		if (
			this.$refs.changePasswordLastPassword.flags.valid &&
			this.$refs.changePasswordNewPassword.flags.valid &&
			this.$refs.changePasswordConfirmPassword.flags.valid
		)
			this.$store.commit('setError', '');
		let authData = {
			oldPassword: this.changePassword.oldPassword,
			newPassword: this.changePassword.newPassword
		};
		this.$store.commit('setExpiredPassword', false);
		this.$store.dispatch('changePassword', authData);
	}

	signOut() {
		this.showNotification();
		if (this.$store.state.auth.authenticated) {
			this.$store.dispatch('signOut');
			this.closeTabs();
		}
		this.signIn.userName = '';
		this.signIn.password = '';
		this.signIn.showPassword = false;
		this.goToSignIn();
	}

	handleScroll(el) {
		if (el.target.offsetHeight + el.target.scrollTop >= el.target.scrollHeight - 35) {
			this.scrolledToBottom = true;
		}
	}

	mfaWarn() {
		this.displaySuccess = false;
		this.displayError = false;
		this.displayWarning = true;
	}

	debounceValidateRegisterInfo = _.debounce(this.validateRegisterInfo, 200, false);

	validateRegisterInfoDebounced() {
		this.debounceValidateRegisterInfo();
	}

	validateRegisterInfo() {
		this.$refs.registrationUserName.validate();
		this.$refs.registrationPassword.validate();
		this.$refs.registrationConfirmPassword.validate();
		if (
			this.$refs.registrationUserName.flags.valid &&
			this.$refs.registrationPassword.flags.valid &&
			this.$refs.registrationConfirmPassword.flags.valid
		) {
			this.isInvalidRegisterInfo = false;
		} else {
			this.isInvalidRegisterInfo = true;
		}
	}

	debounceValidateEmail = _.debounce(this.validateEmail, 200, false);

	validateEmailDebounced() {
		this.debounceValidateEmail();
	}

	validateEmail() {
		this.$refs.forgotPasswordEmail.validate();
		if (this.$refs.forgotPasswordEmail.flags.valid) {
			this.isInvalidEmail = false;
		} else {
			this.isInvalidEmail = true;
		}
	}

	debounceValidateForgotPassword = _.debounce(this.validateForgotPassword, 200, false);

	validateForgotPasswordDebounced() {
		this.debounceValidateForgotPassword();
	}

	validateForgotPassword() {
		this.$refs.resetPasswordResetCode.validate();
		this.$refs.resetPasswordNewPassword.validate();
		this.$refs.resetPasswordConfirmPassword.validate();
		if (
			this.$refs.resetPasswordResetCode.flags.valid &&
			this.$refs.resetPasswordNewPassword.flags.valid &&
			this.$refs.resetPasswordConfirmPassword.flags.valid
		) {
			this.isInvalidForgotPasswordInfo = false;
		} else {
			this.isInvalidForgotPasswordInfo = true;
		}
	}
}
</script>
<style lang="scss" @scoped>
.card-padding {
	padding-top: 0;
	padding-bottom: 8%;
}
.sign-in-header {
	padding-top: 1.5%;
	h1 {
		text-align: left;
		font: normal normal bold 27px/33px Lato !important;
		margin-bottom: 8.5px !important;
		letter-spacing: 0px;
		color: #333333;
		opacity: 1;
	}
}

.leftPanel {
	padding-right: 5px;
	opacity: 1;
	@media (max-width: 767px) {
		background: transparent url('../../assets/mobile-banner.svg') 0% 0% no-repeat padding-box;
		height: 324px;
		width: 350px;
		margin: auto;
	}
	@media (min-width: 768px) and (max-width: 991px) {
		background: transparent url('../../assets/tablet-banner.svg') 0% 0% no-repeat padding-box;
	}
	@media (min-width: 992px) {
		background: transparent url('../../assets/login-banner.svg') 0% 0% no-repeat padding-box;
	}
}

.card-content {
	@media (min-width: 768px) {
		padding-left: 55px;
	}
	@media (max-width: 767px) {
		padding-left: 30px;
	}
}

.card-border {
	@media (max-width: 450px) {
		border: none;
	}
}

.currentPage {
	height: 15px;
	width: 15px;
	padding-left: 10px;
	background-color: #2572b4;
	border: 1px solid #dcdee1;
	border-radius: 100%;
	display: inline-block;
}

.progress-spacing {
	height: 15px;
	width: 7px;
	padding-left: 10px;
	background-color: #ffffff;
	border: 0;
	display: inline-block;
}

.notCurrentPage {
	height: 15px;
	width: 15px;
	padding-left: 10px;
	background-color: #ffffff;
	border: 1px solid #dcdee1;
	border-radius: 100%;
	display: inline-block;
}

.dot-padding {
	padding-top: 10px;
	//padding-right: 10px;
	@media (max-width: 450px) {
		text-align: center;
	}
	@media (min-width: 450px) {
		text-align: right;
	}
}

.agreementText {
	position: relative;
	height: 380px;
	overflow-y: scroll;
}

/* Scrollbars */
.agreementText::-webkit-scrollbar {
	width: 10px;
}

.agreementText::-webkit-scrollbar-track {
	background: #f1f1f1;
	border-radius: 10px;
}

.agreementText::-webkit-scrollbar-thumb {
	background: #888;
	border-radius: 10px;
}

.agreementText::-webkit-scrollbar-thumb:hover {
	background: #555;
}

.agreementPadding {
	padding-bottom: 30px;
}

.mfaInfoText {
	position: relative;
	height: 380px;
	overflow-y: scroll;
}

.mfaInfoText::-webkit-scrollbar {
	width: 10px;
}

.mfaInfoText::-webkit-scrollbar-track {
	background: #f1f1f1;
	border-radius: 10px;
}

.mfaInfoText::-webkit-scrollbar-thumb {
	background: #888;
	border-radius: 10px;
}

.mfaInfoText::-webkit-scrollbar-thumb:hover {
	background: #555;
}

.mfaInfoPadding {
	padding-bottom: 34px;
}

.inputBox {
	margin-bottom: 4px;
}

input::-ms-reveal {
	display: none;
}

.buttonPadding {
	padding-bottom: 32px !important;
	padding-top: 16px !important;
}

.registerButtonPadding {
	padding-bottom: 28px !important;
	padding-top: 16px !important;
}
.confirmButton {
	padding-bottom: 105px !important;
}

.rightButton {
	@media (min-width: 450px) {
		float: right;
	}
	@media (max-width: 450px) {
		margin-top: 15px;
		float: none;
	}
}

.changePasswordLastRow {
	padding-top: 20px;
	padding-bottom: 96px;
}

.subtitle-div {
	padding-bottom: 20px;
	@media (max-width: 450px) {
		h2 {
			text-align: center !important;
		}
	}
}

.success-title {
	padding-top: 15px;
	padding-bottom: 43px;
	@media (max-width: 450px) {
		h2 {
			text-align: center !important;
		}
	}
}

.success-margin {
	margin-top: 40px;
}

.success-image {
	@media (max-width: 450px) {
		display: block;
		margin-left: auto;
		margin-right: auto;
	}
	@media (min-width: 450px) {
		display: inline-block;
		vertical-align: middle;
	}
}

.success-text {
	@media (max-width: 450px) {
		p {
			text-align: center !important;
		}
	}
}

.contentTextPadding {
	padding-bottom: 75px;
	padding-right: 0px;
}

.success-change-password-image {
	@media (min-width: 450px) {
		padding-top: 25px;
		display: inline-block;
		vertical-align: middle;
	}
	@media (max-width: 450px) {
		display: block;
		margin-left: auto;
		margin-right: auto;
	}
}

.successChangePasswordTitlePadding {
	padding-top: 40px;
	padding-bottom: 43px;
}

.continueButton {
	padding-right: 0px;
}

/* title transitions */
.title-slide-enter-active,
.title-slide-leave-active {
	transition: 0.5s;
}

.title-slide-enter {
	transform: translate(100%, 0);
}

.title-slide-leave-to {
	transform: translate(-100%, 0);
}

.title-slide-back-enter-active,
.title-slide-back-leave-active {
	transition: 0.5s;
}

.title-slide-back-enter {
	transform: translate(-100%, 0);
}

.title-slide-back-leave-to {
	transform: translate(100%, 0);
}

.title-slider {
	overflow: hidden;
	position: relative;
	padding-top: 23px !important;
	padding-bottom: 23px;
	overflow: hidden;
	width: 100%;
	@media (max-width: 450px) {
		height: 135px;
		h1 {
			text-align: center;
			font: normal normal bold 27px/36px Lato;
			letter-spacing: 0px;
			color: #333333;
			opacity: 1;
		}
	}
	@media (min-width: 450px) {
		height: 120px;
		h1 {
			text-align: left;
			font: normal normal bold 27px/33px Lato !important;
			letter-spacing: 0px;
			color: #333333;
			opacity: 1;
		}
	}
}

.title-slider .title-div {
	position: absolute;
	padding-top: 23px !important;
	padding-bottom: 23px;
	width: 100%;

	@media (max-width: 450px) {
		height: 135px;
		h1 {
			text-align: center;
			font: normal normal bold 27px/36px Lato;
			letter-spacing: 0px;
			color: #333333;
			opacity: 1;
		}
	}
	@media (min-width: 450px) {
		height: 120px;
		h1 {
			text-align: left;
			font: normal normal bold 27px/33px Lato !important;
			letter-spacing: 0px;
			color: #333333;
			opacity: 1;
		}
	}
}

/* page transitions */
.slide-enter-active,
.slide-leave-active {
	transition: 0.5s;
}

.slide-enter {
	transform: translate(100%, 0);
}

.slide-leave-to {
	transform: translate(-100%, 0);
}

.slide-back-enter-active,
.slide-back-leave-active {
	transition: 0.5s;
}

.slide-back-enter {
	transform: translate(-100%, 0);
}

.slide-back-leave-to {
	transform: translate(100%, 0);
}

.form-slider {
	position: relative;
	@media (min-width: 768px) {
		overflow: hidden;
		height: 555px;
	}
	@media (max-width: 767px) {
		overflow-x: hidden;
		overflow-y: auto;
		height: 1100px;
		padding-bottom: 25px;
	}
	width: 100%;
}

.form-slider-small {
	position: relative;
	@media (min-width: 768px) {
		overflow: hidden;
		height: 555px;
	}
	@media (max-width: 767px) {
		/* overflow-x: hidden; 
        overflow-y: auto;*/
		height: 550px;
		padding-bottom: 25px;
	}
	width: 100%;
}

.form-slider .form-div,
.form-slider-small .form-div {
	position: absolute;
	@media (min-width: 450px) {
		height: 575px;
	}
	@media (max-width: 450px) {
		height: 1100px;
	}
	width: 100%;
	h2 {
		text-align: left;
		font: normal normal bold 20px/24px Lato;
		letter-spacing: 0px;
		color: #333333;
		opacity: 1;
	}
	label {
		text-align: left;
		font: normal normal bold 17px/42px Noto Sans;
		letter-spacing: 0px;
		opacity: 1;
	}
	p {
		text-align: left;
		font: normal normal normal 16px/22px Noto Sans;
		letter-spacing: 0px;
		color: #262626;
		opacity: 1;
	}
	a {
		text-align: left;
		text-decoration: underline;
		font: normal normal normal 17px/23px Noto Sans;
		letter-spacing: 0px;
		color: #284162;
		opacity: 1;
	}
	ul {
		list-style-type: circle !important;
	}
}

/*checklist transitions*/

.checklist-slide-enter-active,
.checklist-slide-leave-active {
	transition: 0.5s;
}

.checklist-slide-enter {
	transform: translate(100%, 0);
}

.checklist-slide-leave-to {
	transform: translate(-100%, 0);
}

.checklist-slide-back-enter-active,
.checklist-slide-back-leave-active {
	transition: 0.5s;
}

.checklist-slide-back-enter {
	transform: translate(-100%, 0);
}

.checklist-slide-back-leave-to {
	transform: translate(100%, 0);
}

.checklist-slider {
	position: relative;
	padding-left: 0px !important;
	@media (min-width: 1100px) {
		height: 555px;
		width: 425px;
		padding-top: 85px;
	}
	@media (max-width: 1100px) and (min-width: 820px) {
		height: 555px;
		width: 325px;
		padding-top: 85px;
	}
	@media (max-width: 820px) {
		height: 650px;
		width: 227px;
		padding-top: 15px;
	}
	opacity: 0.9;
	h2 {
		text-align: left;
		margin-left: 15px;
		margin-top: 10px;
		font: normal normal normal 20px/24px Lato;
		letter-spacing: 0px;
		color: #ffffff;
		opacity: 1;
	}

	hr {
		border: 1px solid #d40811;
		width: 90%;
	}

	ul {
		text-align: left;
		font: normal normal normal 16px/32px Noto Sans;
		padding-left: 35px;
		letter-spacing: 0px;
		color: #ffffff;
		opacity: 1;
	}
}

.checklist-slider .checklist-div {
	position: absolute;
	overflow-y: auto;

	@media (min-width: 992px) {
		background: transparent url('../../assets/benefits-theme.svg') 0% 0% no-repeat padding-box;
		height: 493px;
		width: 375px;
		padding-right: 50px;
		padding-left: 0px !important;
		margin-left: 50px;
	}

	@media (max-width: 991px) {
		background: transparent url('../../assets/benefits-theme-tablet.svg') 0% 0% no-repeat padding-box;
		height: 493px;
		width: 205px;
		padding-left: 0px !important;
		margin-left: 15px;
	}
}

/* Scrollbars */
.checklist-div::-webkit-scrollbar {
	width: 10px;
}

.checklist-div::-webkit-scrollbar-track {
	background: #f1f1f1;
	border-radius: 10px;
}

.checklist-div::-webkit-scrollbar-thumb {
	background: #888;
	border-radius: 10px;
}

.checklist-div::-webkit-scrollbar-thumb:hover {
	background: #555;
}

.checklist-mobile-div {
	background: transparent url('../../assets/benefits-theme.svg') 0% 0% no-repeat padding-box;
	overflow-y: scroll;
	height: 493px;
	background-size: cover;
	h2 {
		text-align: left;
		margin-left: 15px;
		margin-top: 10px;
		font: normal normal normal 20px/24px Lato !important;
		letter-spacing: 0px;
		color: #ffffff !important;
		opacity: 1;
	}

	hr {
		border: 1px solid #d40811;
		width: 95%;
		margin-right: 0;
	}

	ul {
		text-align: left;
		font: normal normal normal 16px/32px Noto Sans;
		letter-spacing: 0px;
		color: #ffffff;
		opacity: 1;
	}
}

#signin-register-form,
#signin-register-title {
	overflow: hidden;
}

#sign-in-requirements {
	overflow: hidden;
	@media (max-width: 767px) {
		display: none;
	}
}

#sign-in-requirements-mobile {
	@media (min-width: 768px) {
		display: none;
	}
	padding-top: 16px;
	padding-bottom: 15px;
}

.link-text {
	@media (max-width: 450px) {
		p {
			text-align: center !important;
		}
		a {
			text-align: center !important;
		}
	}
	@media (min-width: 450px) {
		p {
			text-align: left;
		}
		a {
			text-align: left;
		}
	}
	p {
		//text-align: left;
		font: normal normal normal 17px/24px Noto Sans !important;
		letter-spacing: 0px;
		color: #707070 !important;
		opacity: 1;
	}
	a {
		//text-align: left;
		text-decoration: underline;
		font: normal normal normal 17px/23px Noto Sans;
		letter-spacing: 0px;
		color: #284162;
		opacity: 1;
	}
}

/* notifications */
.errorNotification {
	padding-top: 5%;
	background: #ffffff 0% 0% no-repeat padding-box;
	min-height: 118px;
	padding-left: 1%;
	h2 {
		text-align: left;
		font: normal normal bold 26px/32px Lato;
		letter-spacing: 0px;
		padding-left: 35px;
		padding-top: 20px;
		color: #000000;
		opacity: 1;
	}
	p {
		text-align: left;
		font: normal normal normal 20px/26px Noto Sans;
		letter-spacing: 0px;
		padding-left: 35px;
		color: #000000;
		opacity: 1;
	}
}

.errorNotification::before {
	font-family: 'Glyphicons Halflings';
	font-size: 26px;
	line-height: 2.3em;
	padding: 2px;
	position: absolute;
	color: #d40811;
	content: url('../../assets/error-icon.png');
}

.warnNotification {
	padding-top: 5%;
	background: #ffffff 0% 0% no-repeat padding-box;
	min-height: 118px;
	padding-left: 1%;
	h2 {
		text-align: left;
		font: normal normal bold 26px/32px Lato;
		letter-spacing: 0px;
		padding-left: 35px;
		padding-top: 20px;
		color: #000000;
		opacity: 1;
	}
	p {
		text-align: left;
		font: normal normal normal 20px/26px Noto Sans;
		letter-spacing: 0px;
		padding-left: 35px;
		color: #000000;
		opacity: 1;
	}
}

.warnNotification::before {
	font-family: 'Glyphicons Halflings';
	font-size: 26px;
	line-height: 2.3em;
	padding: 2px;
	position: absolute;
	color: #d40811;
	content: url('../../assets/warning-icon.png');
}

.successNotification {
	background: #ffffff 0% 0% no-repeat padding-box;
	min-height: 118px;
	padding: 1%;
	h2 {
		text-align: left;
		font: normal normal bold 26px/32px Lato;
		letter-spacing: 0px;
		padding-left: 35px;
		padding-top: 20px;
		color: #000000;
		opacity: 1;
	}
	p {
		text-align: left;
		font: normal normal normal 20px/26px Noto Sans;
		letter-spacing: 0px;
		padding-left: 35px;
		color: #000000;
		opacity: 1;
	}
}

.successNotification::before {
	font-family: 'Glyphicons Halflings';
	font-size: 26px;
	line-height: 2.3em;
	padding: 2px;
	position: absolute;
	color: #278400;
	content: url('../../assets/success-icon.png');
}

.eye-icon {
	background-color: #f8f9fa;
	height: 33px;
}

.show-password {
	color: #2572b4;
	margin: 0px;
	padding: 0px;
	width: 30px;
	float: right;
	position: relative;
	top: -40px;
	margin-bottom: -40px;
}

.forgot-password {
	padding-top: 16px;
}

.second-auth {
	padding-top: 16px;
}

.resend-confirm {
	padding-top: 16px;
	padding-bottom: 35px;
}

.label-danger {
	font: normal normal bold 16px/21px Noto Sans;
	border: none;
	border-radius: 0;
	border-left: 4px solid #d3080c;
	color: #000;
	margin-top: 0;
	padding-top: 5px;
	padding-bottom: 5px;
	padding-left: 5px;
	height: auto;
	text-align: left;
	background: #f3e9e8;
	//white-space: nowrap;
	line-height: 27px;
}

.label-none {
	border: none;
	border-radius: 0;
	margin-top: 0px;
	padding-top: 5px;
	padding-bottom: 5px;
	padding-left: 5px;
	height: auto;
	text-align: left;
}

//loading icon
#loadingIcon {
	color: #fff;
	width: 100px;
	height: 100px;
	padding: 12px;
}
#loadingBox {
	background-color: #4c4c4c;
	border-radius: 10px;
	width: 100px;
	height: 100px;
	position: relative;
	left: calc(50% - 50px);
}
#loadingContainer {
	position: sticky;
	bottom: 400px;
	left: 0px;
	width: 100%;
	height: 100%;
	opacity: 0.9;
	z-index: 999999;
}
</style>
<!-- *************************************************************************
		TRANSLATIONS
		************************************************************************* -->

<i18n>
	{
		"en": {	
			"required": " (required)",	
			"signIn": {
				"signInHeader": "Welcome to the IFHP-Medavie Secure Beneficiary Web Portal",
				"signInTitle" : "Log In",
				"signUpLink": "Register", 
				"signUp" : " if you are a new user",
				"forgotPasswordLink": "Forgot Password?",
				"buttonLogin": "Login",
				"userName": "Email",
				"password": "Password"
			},	
			"registerAgreement": {
				"registerTermsTitle" : "Register",		
				"agreementTitle": "User Agreement",
				"buttonNext" : "Accept"
			},
			"registration": {
				"registerTitle": "Enter your email and create a password",
				"buttonBack": "Back",
				"buttonSubmit": "Next",
				"userName": "Email",
				"password": "Password",
				"confirmPassword": "Confirm Password"
			},
			"registerConfirm": {
				"registerConfirmTitle": "Enter your verification code",
				"verificationDesc": "For account protection, we've emailed you a verification code. Please enter it below to continue.",
				"verificationCode": "Code",
				"buttonResend": "Re-send the verification code",
				"buttonConfirm": "Verify Code"
			},
			"registered": {
				"registeredTitle": "Success",
				"verificationMessage": "Your verification code has been confirmed. Please continue to log in.",
				"buttonSignIn": "Continue"
			},
			"forgotPassword": {
				"forgotPassword": "Forgot Password",
				"forgotPasswordSubTitle": "Email",
				"forgotPasswordMessage": "Enter your email and we'll send you a verification code to reset your password.",
				"email": "Email",
				"nextButton": "Next",
				"cancelButton": "Cancel"
			},
			"resetPassword": {
				"resetCode": "Access Code",
				"newPassword": "New Password",
				"confirmPassword": "Confirm Password",
				"cancelButton": "Cancel",
				"changePasswordButton": "Change My Password",
				"resendCodeMsg1": "Didn't receive an email with your access code? ",
				"buttonResend": "We can resend the access code."
			},			
			"passwordRequirements": {
				"title": "Password Checklist",
				"rule1": "15 to 99 characters",
				"rule2": "At least one (1) uppercase letter",
				"rule3": "At least one (1) lowercase letter",
				"rule4": "At least two (2) numbers",
				"rule5": "At least one (1) non-alphanumeric character (e.g.: %$#)",
				"rule6": "There must be at least three (3) unique characters in your password.",
				"rule7": "You cannot reuse an old password.",
				"rule8": "Your password must not contain your first or last name.",
				"rule9": "Your password must not contain the email address you use to log in."
			},
			"mfaInfo": {
				"mfaInfoTitle": "Multi-Factor Authentication ",
				"mfaInfoHeader": "MFA Information",
				"mfaDescParagraph1": "In your previous session, you chose to activate multi-factor authentication (MFA) on your account to make your account more secure and protect your information. We’re now going to walk you through a series of steps to complete set up.",
				"mfaDescParagraph2": "You’ll only need to go through these steps once. ",
				"mfaDescParagraph3": "Before you get started, you’ll need to download the Microsoft Authenticator app or Google Authenticator app from either Google Play or the iOS App Store. When you’re ready, click continue. ",
				"mfaDescParagraph4": "Don’t want to go forward with using MFA right now? You can go back and resume using your account profile without MFA.",
				"buttonMFAOff": "Don’t want to proceed with MFA",
				"buttonContinue": "Continue"
			},
			"mfaSetup": {
				"mfaSetupHeader": "QR verification code",
				"mfaSetupText": "Information about MFA and how to scan the code in mobile and desktop. The code will change in every 30 second.",
				"mfaSetupText2": "For more details ",
				"mfaSetupLink": "click here(Handbook)",
				"qrCodeInput": "QR code",
				"mfaBackButton": "Back",
				"mfaVerifyButton": "Verify Code",
				"mfaVerifyText": "Information about MFA. Check the mobile app for the code.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed."
			},
			"secondAuth": {
				"mfaInfoTitle": "Multi-Factor Authentication",
				"mfaSetupHeader": "QR verification code",
				"mfaSetupText": "Use the authenticator app on your mobile device to generate the 6-digit verification code you will need to enter to continue to your account.",
				"qrCodeInput": "Verification code",
				"mfaVerifyButton": "Verify Code"
			},
			"changePassword": {
				"changePassword" : "Change My Password",
				"lastPassword": "Old Password",
				"newPassword": "New Password",
				"confirmPassword": "Confirm Password",
				"changePasswordButton": "Change My Password",
				"cancelButton": "Cancel"
			},
			"changeSuccess": {
				"continueButton": "Continue",
				"changePasswordSuccessTitle": "Password changed successfully",
				"successMessage": "Your password has been successfully updated. For account protection, you will be reminded to update your password every 180 days.",
				"successMessageAddtl": "Please continue to the home page."
			},
			"successMsg": {
				"passwordResetTitle": "Password changed successfully",
				"passwordReset": "Your password has been successfully updated. For account protection, you will be reminded to update your password every 180 days.",
				"resentCodeTitle": "Your verification code has been sent.",
				"resentCode": "Please check your email."
			},
			"warnMsg": {
				"warnNotifTitle": "MFA",
				"warnNotifMessage1": "Please click on ",
				"warnNotifLink": "confirm",
				"warnNotifMessage2": ", if you don't want to proceed with MFA"
			},
			"errmsg": {
				"errmsgTitle": "Error",
				"incorrectCredentials" : "Incorrect username or password", 
				"userNameExists": "The email you entered has already been registered to an account. Please go to the log in page to access your account.",
				"invalidVerification": "Invalid verification code provided. Please double check your code and try again.", 
				"userAlreadyConfirmed": "The user has already been confirmed",
				"userNotFound" : "User not found",
				"registrationNotConfirmed": "Your registration has not been confirmed. Please enter the verification code and try again.",
				"limitExceededChangePassword": "For security purposes, we have temporarily disabled the change password feature. Please try again later.",
				"limitExceededForgotPassword": "For security purposes, we have temporarily disabled the forgot password feature. Please try again later.",
				"limitExceededLocked": "For security purposes, your account has been temporarily locked. Please try again later.",
				"mfaCodeInvalid": "Code is not valid",
				"registrationError": "Registration Error",
				"userProfileNotFound": "We apologize. We’re experiencing issues accessing your account. Please contact our customer care team for assistance.",
				"userProfileError": "We apologize. We're experiencing issues accessing your account and should be back shortly. Please try again later.",
				"timeoutError": "This request is taking a bit too long. Please try your request again later.",
				"default": "An error has occured.",
				"userEligibilityError": "We apologize. We're experiencing issues. Please try again later."
			},
			"aria": {
				"showPassword": "show password",
				"hidePassword": "hide password"
			}
	
		},
		"fr": {
			"required": "(obligatoire)",
			"signIn": {
				"signInHeader": "Bienvenue au portail web sécurisé des bénéficiares du PFSI-Medavie",
				"signInTitle" : "Ouvrir une session",
				"signUpLink": "Inscrivez-vous", 
				"signUp" : " si vous êtes un nouvel utilisateur.",
				"forgotPasswordLink": "Vous avez oublié votre mot de passe?",
				"buttonLogin": "Ouvrir une session",
				"userName": "Adresse courriel",
				"password": "Mot de passe"
			},	
			"registerAgreement": {
				"registerTermsTitle" : "S’inscrire",		
				"agreementTitle": "Entente d’utilisation",
				"buttonNext" : "Accepter"
			},
			"registration": {
				"registerTitle": "Entrez votre adresse courriel et créez un mot de passe.",
				"buttonBack": "Précédent",
				"buttonSubmit": "Suivant",
				"userName": "Adresse courriel",
				"password": "Mot de passe",
				"confirmPassword": "Confirmer le mot de passe"
			},
			"registerConfirm": {
				"registerConfirmTitle": "Entrez votre code de vérification",
				"verificationDesc": "Afin de protéger votre compte, nous vous avons envoyé un code de vérification par courriel. Veuillez l’entrer ci-dessous pour continuer.",
				"verificationCode": "Code",
				"buttonResend": "Renvoyer le code de vérification ",
				"buttonConfirm": "Vérifier le code"
			},
			"registered": {
				"registeredTitle": "Réussite",
				"verificationMessage": "Votre code de vérification est confirmé. Veuillez continuer pour ouvrir une session.",
				"buttonSignIn": "Continuez"
			},
			"forgotPassword": {
				"forgotPassword": "Mot de passe oublié",
				"forgotPasswordSubTitle": "Adresse courriel",
				"forgotPasswordMessage": "Entrez votre adresse courriel et nous vous enverrons un code de vérification pour réinitialiser votre mot de passe.",
				"email": "Adresse courriel",
				"nextButton": "Suivant",
				"cancelButton": "Annuler"
			},
			"resetPassword": {
				"resetCode": "Code d’accès",
				"newPassword": "Nouveau mot de passe",
				"confirmPassword": "Confirmer le mot de passe",
				"changePasswordButton": "Modifier mon mot de passe",
				"cancelButton": "Annuler",
				"resendCodeMsg1": "Vous n’avez pas reçu votre code d’accès par courriel?",
				"buttonResend": "Nous pouvons vous le renvoyer."
			},		
			"passwordRequirements": {
				"title": "Liste de vérification des exigences du mot de passe",
				"rule1": "15 à 99 caractères",
				"rule2": "au moins une (1) lettre majuscule",
				"rule3": "au moins une (1) lettre minuscule",
				"rule4": "au moins deux (2) chiffres",
				"rule5": "au moins un (1) caractère non alphanumérique (p. ex. : %$#)",
				"rule6": "Il doit y avoir au moins trois (3) caractères uniques dans votre mot de passe.",
				"rule7": "Vous ne pouvez pas réutiliser un ancien mot de passe.",
				"rule8": "Votre mot de passe ne doit pas contenir votre prénom ou votre nom de famille.",
				"rule9": "Votre mot de passe ne doit pas contenir l’adresse courriel que vous utilisez pour vous connecter."
			},
			"mfaInfo": {
				"mfaInfoTitle": "Multi-Factor Authentication [FR]",
				"mfaInfoHeader": "MFA Information [FR]",
				"mfaDescParagraph1": "In your previous session, you chose to activate multi-factor authentication (MFA) on your account to make your account more secure and protect your information. We’re now going to walk you through a series of steps to complete set up. [FR]",
				"mfaDescParagraph1": "You’ll only need to go through these steps once. [FR]",
				"mfaDescParagraph1": "Before you get started, you’ll need to download the Microsoft Authenticator app or Google Authenticator app from either Google Play or the iOS App Store. When you’re ready, click continue. [FR]",
				"mfaDescParagraph1": "Don’t want to go forward with using MFA right now? You can go back and resume using your account profile without MFA. [FR]",
				"buttonMFAOff": "Don’t want to proceed with MFA [FR]",
				"buttonContinue": "Continuez"
			},
			"mfaSetup": {
				"mfaSetupHeader": "QR verification code [FR]",
				"mfaSetupText": "Information about MFA and how to scan the code in mobile and desktop. The code will change in every 30 second. [FR]",
				"mfaSetupText2": "For more details ",
				"mfaSetupLink": "click here(Handbook) [FR]",
				"qrCodeInput": "QR code [FR]",
				"mfaBackButton": "Back [FR]",
				"mfaVerifyButton": "Vérifier le code",
				"mfaVerifyText": "Information about MFA. Check the mobile app for the code.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed. [FR]"
			},
			"secondAuth": {
				"mfaInfoTitle": "Multi-Factor Authentication [FR]",
				"mfaSetupHeader": "QR verification code [FR]",
				"mfaSetupText": "Use the authenticator app on your mobile device to generate the 6-digit verification code you will need to enter to continue to your account. [FR]",
				"qrCodeInput": "Verification code [FR]",
				"mfaVerifyButton": "Vérifier le code"
			},
			"changePassword": {
				"changePassword" : "Modifier le mot de passe",
				"lastPassword": "Ancien mot de passe",
				"newPassword": "Nouveau mot de passe",
				"confirmPassword": "Confirmer le mot de passe",
				"changePasswordButton": "Modifier mon mot de passe",
				"cancelButton": "Annuler"
			},
			"changeSuccess": {
				"continueButton": "Continuez",
				"changePasswordSuccessTitle": "Le mot de passe a été modifié",
				"successMessage": "Votre mot de passe a été modifié. Afin de protéger votre compte, vous devrez changer votre mot de passe tous les 180 jours.",
				"successMessageAddtl": "Veuillez continuer vers la page d’accueil."
			},
			"successMsg": {
				"passwordResetTitle": "Le mot de passe a été modifié",
				"passwordReset": "Votre mot de passe a été modifié. Afin de protéger votre compte, vous devrez changer votre mot de passe tous les 180 jours",
				"resentCodeTitle": "Votre code de vérification a été envoyé.",
				"resentCode": "Veuillez vérifier vos courriels."
	
			},
			"warnMsg": {
				"warnNotifTitle": "MFA [FR]",
				"warnNotifMessage1": "Please click on ",
				"warnNotifLink": "confirm",
				"warnNotifMessage2": ", if you don't want to proceed with MFA [FR]"
			},
			"errmsg": {
				"errmsgTitle": "Alerte",
				"incorrectCredentials" : "Nom d’utilisateur ou mot de passe incorrect.", 
				"userNameExists": "L’adresse courriel que vous avez entrée est déjà associée à un compte. Veuillez visiter la page d’ouverture de session pour accéder à votre compte.",
				"invalidVerification": "Le code de vérification fourni est invalide. Veuillez vérifier qu’il s’agit du bon code et essayez de nouveau.", 
				"userAlreadyConfirmed": "The user has already been confirmed [FR]",
				"userNotFound" : "Une erreur inattendue s’est produite Utilisateur introuvable",
				"registrationNotConfirmed": "Votre inscription n’a pas été confirmée. Veuillez entrer le code de vérification et essayez de nouveau.",
				"limitExceededChangePassword": "Pour des raisons de sécurité, nous avons temporairement désactivé la fonction d’oubli du mot de passe. Veuillez réessayer plus tard.",
				"limitExceededForgotPassword": "Pour des raisons de sécurité, nous avons temporairement désactivé la fonction d’oubli du mot de passe. Veuillez réessayer plus tard.",
				"limitExceededLocked": "Pour des raisons de sécurité, votre compte est temporairement bloqué. Veuillez réessayer plus tard.",
				"mfaCodeInvalid": "Code is not valid [FR]",
				"registrationError": "Registration Error [FR]",
				"userProfileNotFound": "Nous sommes désolés. Nous éprouvons actuellement des difficultés à accéder à votre compte. Veuillez contacter un membre de notre équipe du Service à la clientèle.",
				"userProfileError": "Nous sommes désolés. Nous éprouvons actuellement des difficultés à accéder à votre compte. Le problème devrait se régler bientôt, veuillez réessayer plus tard.",
				"timeoutError": "Cette demande prend un peu trop de temps. Veuillez soumettre votre demande plus tard.",
				"default": "Une erreur est survenue.",
				"userEligibilityError": "Nous sommes désolés. Nous éprouvons actuellement des difficultés. Veuillez réessayer plus tard."
			},
			"aria": {
				"showPassword": "Montrer le mot de passe",
				"hidePassword": "Masquer le mot de passe"
			}
		}
	}
	</i18n>
